var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformaInvoices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-tax",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    svg#freepik_stories-tax:not(.animated) .animable {\n      opacity: 0;\n    }\n\n    svg#freepik_stories-tax.animated #freepik--background-complete--inject-2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) fadeIn;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-tax.animated #freepik--Floor--inject-2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-tax.animated #freepik--Clipboard--inject-2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 1s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-tax.animated #freepik--Device--inject-2 {\n      animation: 2.7s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 2s;\n      opacity: 0\n    }\n\n    svg#freepik_stories-tax.animated #freepik--Table--inject-2 {\n      animation: 1.5s Infinite linear heartbeat;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-tax.animated #freepik--Character--inject-2 {\n      animation: 1.5s Infinite linear wind;\n      animation-delay: 0s;\n    }\n\n    @keyframes fadeIn {\n      0% {\n        opacity: 0;\n      }\n\n      100% {\n        opacity: 1;\n      }\n    }\n\n    @keyframes slideUp {\n      0% {\n        opacity: 0;\n        transform: translateY(30px);\n      }\n\n      100% {\n        opacity: 1;\n        transform: inherit;\n      }\n    }\n\n    @keyframes heartbeat {\n      0% {\n        transform: scale(1);\n      }\n\n      10% {\n        transform: scale(1.1);\n      }\n\n      30% {\n        transform: scale(1);\n      }\n\n      40% {\n        transform: scale(1);\n      }\n\n      50% {\n        transform: scale(1.1);\n      }\n\n      60% {\n        transform: scale(1);\n      }\n\n      100% {\n        transform: scale(1);\n      }\n    }\n\n    @keyframes wind {\n      0% {\n        transform: rotate(0deg);\n      }\n\n      25% {\n        transform: rotate(1deg);\n      }\n\n      75% {\n        transform: rotate(-1deg);\n      }\n    }\n\n    .animator-hidden {\n      display: none;\n    }\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    className: "animable",
    style: {
      transformOrigin: "252.544px 244.245px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.35,156c-4.77,0-8.09-3.51-8.09-9.15s3.32-9.14,8.09-9.14,8.13,3.55,8.13,9.14S461.12,156,456.35,156Zm0-3.89c2,0,3.41-1.75,3.41-5.26s-1.4-5.26-3.41-5.26-3.41,1.71-3.41,5.26S454.29,152.09,456.35,152.09Zm2.85,19.14h-5.56l-22.35-33.17h5.56Zm-25.06.38c-4.77,0-8.13-3.55-8.13-9.14s3.36-9.15,8.13-9.15,8.09,3.56,8.09,9.15S438.86,171.61,434.14,171.61Zm0-3.88c2,0,3.42-1.71,3.42-5.26s-1.41-5.26-3.42-5.26-3.41,1.75-3.41,5.26S432.09,167.73,434.14,167.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "445.245px 154.67px"
    },
    id: "elhletxxl8x4a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.62,149a1.13,1.13,0,0,1-.28-.14l-.76-.46a13.11,13.11,0,0,1-1.18-.76c-.45-.32-1-.66-1.5-1.1l-.85-.68c-.3-.23-.58-.51-.89-.77-.62-.53-1.22-1.16-1.86-1.8a37,37,0,0,1-3.72-4.64,37.83,37.83,0,0,1-2.86-5.21c-.34-.85-.69-1.64-.94-2.42-.13-.38-.27-.75-.38-1.11l-.3-1c-.2-.66-.31-1.27-.43-1.81a12.84,12.84,0,0,1-.26-1.38c0-.36-.09-.65-.13-.88a1.44,1.44,0,0,1,0-.31,1.9,1.9,0,0,1,.08.3l.17.87c.07.38.15.84.3,1.37s.25,1.14.47,1.79l.31,1c.11.36.26.72.39,1.1.25.77.61,1.55,1,2.39a39.62,39.62,0,0,0,2.85,5.17,38.13,38.13,0,0,0,3.68,4.61c.63.65,1.23,1.28,1.84,1.81.3.27.58.54.86.78l.84.69c.52.44,1,.79,1.47,1.12s.83.59,1.15.8l.74.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "40.4458px 136.765px"
    },
    id: "eln5jlodjmm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.11,121.19a2.21,2.21,0,0,1-1-.25,4.07,4.07,0,0,1-1.91-1.72,4.18,4.18,0,0,1-.49-2.54,2.35,2.35,0,0,1,.33-1s-.1.4-.15,1a4.21,4.21,0,0,0,2.3,4.08C56.72,121.07,57.12,121.15,57.11,121.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "55.394px 118.435px"
    },
    id: "eljmf191xuxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.87,109.61c-.06,0-.36-.34-.67-.85s-.51-.94-.45-1,.36.34.67.85S56.93,109.58,56.87,109.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "56.31px 108.682px"
    },
    id: "elz25swk4m94s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,95.73a7,7,0,0,1-.73.41c-.24.12-.54.27-.87.47s-.71.39-1.11.66-.85.54-1.31.88-.94.7-1.44,1.09a26.85,26.85,0,0,0-5.52,6.12c-.33.54-.67,1-.93,1.54s-.52,1-.74,1.39-.38.83-.54,1.18-.28.65-.38.91a8.09,8.09,0,0,1-.33.77,4.91,4.91,0,0,1,.24-.81,9.25,9.25,0,0,1,.34-.92c.14-.36.29-.77.51-1.21s.43-.92.71-1.41.59-1,.93-1.57a27.34,27.34,0,0,1,2.53-3.32,28.42,28.42,0,0,1,3-2.86c.51-.39,1-.76,1.47-1.08s.92-.6,1.33-.85.81-.46,1.15-.64.63-.32.88-.43A5,5,0,0,1,52.46,95.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "45.51px 103.44px"
    },
    id: "elt6ut7p0stg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.74,145.61a4.46,4.46,0,0,1-.44.46,17.21,17.21,0,0,1-1.3,1.14,24.51,24.51,0,0,1-4.83,3,24.76,24.76,0,0,1-5.39,1.86c-.71.15-1.3.25-1.7.29a2.77,2.77,0,0,1-.64.05,3.53,3.53,0,0,1,.62-.14c.4-.08,1-.2,1.68-.38A28.2,28.2,0,0,0,79.06,150a27.68,27.68,0,0,0,4.83-2.94c.58-.44,1-.81,1.34-1.08S85.72,145.59,85.74,145.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "78.59px 149.01px"
    },
    id: "els1uwbs9k4ai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,78.28s-.06,0-.16-.18-.27-.31-.45-.53-.42-.52-.66-.87-.54-.74-.81-1.2l-.45-.72c-.15-.25-.29-.53-.44-.8-.32-.55-.59-1.17-.9-1.82a29,29,0,0,1-1.5-4.37,30.09,30.09,0,0,1-.73-4.58c0-.71-.07-1.38-.05-2,0-.31,0-.62,0-.91s0-.58.06-.84c0-.54.1-1,.15-1.45s.12-.79.18-1.08.1-.5.14-.68a.79.79,0,0,1,.06-.23.87.87,0,0,1,0,.24c0,.18-.06.4-.1.68s-.11.66-.15,1.09-.11.9-.12,1.44l0,.83c0,.3,0,.6,0,.91,0,.63,0,1.3.08,2a29.62,29.62,0,0,0,.73,4.54,30.32,30.32,0,0,0,1.48,4.35c.3.64.57,1.26.87,1.81.15.28.29.55.44.8l.43.72c.26.47.55.86.78,1.21a9.16,9.16,0,0,0,.64.89c.16.23.3.42.41.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "88.9232px 67.15px"
    },
    id: "elqhsf2wryefc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.55,60.11a1.55,1.55,0,0,1-.7-.45,3.15,3.15,0,0,1-.64-3.75c.24-.47.49-.68.51-.66s-.18.26-.38.72a3.34,3.34,0,0,0-.25,1.89,3.41,3.41,0,0,0,.86,1.7C105.29,59.93,105.56,60.08,105.55,60.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "104.703px 57.6793px"
    },
    id: "elclrs5liupti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.41,51.56a3.85,3.85,0,0,1-.34-1.64c.06,0,.18.35.27.8S108.47,51.55,108.41,51.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "108.254px 50.74px"
    },
    id: "elkczh47pksp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.83,40.22a5.37,5.37,0,0,1-.65.11,7.54,7.54,0,0,0-.75.12c-.29,0-.63.1-1,.19s-.77.17-1.19.3-.87.26-1.35.42a20.85,20.85,0,0,0-5.65,3c-.39.3-.77.58-1.09.88s-.64.57-.91.83-.5.5-.71.72a7.45,7.45,0,0,0-.51.56,3.85,3.85,0,0,1-.45.48,5,5,0,0,1,.39-.53c.12-.16.29-.37.49-.59s.42-.48.69-.74.56-.56.9-.85.7-.6,1.09-.91a19.64,19.64,0,0,1,5.7-3.06c.48-.16.93-.31,1.36-.41s.84-.21,1.21-.28.71-.12,1-.16.56-.07.77-.09A5.24,5.24,0,0,1,108.83,40.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "101.7px 44.017px"
    },
    id: "el2lmd7x8hyy7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.11,85.55a2.29,2.29,0,0,1-.44.22,12.77,12.77,0,0,1-1.25.5,20,20,0,0,1-4.34,1,18.76,18.76,0,0,1-4.44-.06,11,11,0,0,1-1.33-.23,2,2,0,0,1-.48-.13,2.92,2.92,0,0,1,.5.06c.31,0,.76.11,1.32.16a21.67,21.67,0,0,0,8.72-.89c.54-.17,1-.32,1.27-.43A2.68,2.68,0,0,1,120.11,85.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "113.97px 86.4618px"
    },
    id: "elroakd5r658m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.16,226.18s-8.46-.61-7.68,18.37,2.72,29.09,2.72,29.09-.25,4.21-3.51,3.38-9.39-4.92-12.42-1.86-2,8,2.14,13.78,12.83,18.64,13.61,19.81,1.07,3.31-1.24,3.1-17.9-5.49-20,2.06S416,335.53,417.5,337.1s1.61,2.56,1,3.51-5.69-1.33-10.19-2.65-9.94-2.06-10.77,2.39,5.44,17.5,28.92,31.21l11.29,5.63,10.69-6.81c22-16,26.92-29.59,25.65-33.94s-6.61-3.07-10.95-1.3-9.17,4.53-9.88,3.65-.73-1.88.63-3.59,14.12-17.14,11.31-24.45-17.8-.49-20.08-.05-2.19-1.73-1.54-2.95,8-14.95,11.56-21.08,4.2-11.08.75-13.92-9,1.94-12.17,3.09-3.83-3-3.83-3,.92-10.26-.2-29.22S430,226.18,430,226.18",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "435.872px 301.671px"
    },
    id: "eluwuw3ucd0xa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.83,243.18s0,.13.05.39.05.67.09,1.17c.07,1,.17,2.55.3,4.48.26,3.89.59,9.53,1,16.49.77,13.93,1.68,33.19,2.61,54.45s1.78,40.53,2.48,54.46c.35,6.95.64,12.58.84,16.5.09,1.93.17,3.44.22,4.49,0,.49,0,.88.05,1.16v.4a2.94,2.94,0,0,1-.05-.39q0-.42-.09-1.17c-.07-1-.17-2.55-.3-4.48-.26-3.89-.59-9.53-1-16.49-.77-13.93-1.68-33.19-2.61-54.46s-1.78-40.52-2.48-54.45c-.35-7-.64-12.58-.84-16.5-.09-1.93-.17-3.44-.22-4.49,0-.5,0-.88-.05-1.16A4,4,0,0,1,430.83,243.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "434.647px 320.175px"
    },
    id: "elhff9eha3a4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.62,281.24a3.44,3.44,0,0,1,.7.58c.43.4,1,1,1.79,1.72,1.49,1.48,3.49,3.57,5.66,5.92l5.53,6.05,1.68,1.82c.39.43.61.68.58.7a4,4,0,0,1-.7-.58c-.44-.4-1.05-1-1.79-1.73-1.47-1.49-3.45-3.61-5.62-6s-4.06-4.39-5.56-6l-1.69-1.82C417.8,281.51,417.59,281.26,417.62,281.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "425.59px 289.635px"
    },
    id: "elcpsek4595gm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.69,297.66c-.09-.09,4-4.41,9.22-9.66s9.45-9.44,9.53-9.36-4,4.41-9.22,9.66S434.77,297.74,434.69,297.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "444.065px 288.15px"
    },
    id: "el8xz4gpzj0kh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.64,330.38a4.8,4.8,0,0,1,.79-.5l2.21-1.24c1.86-1.05,4.43-2.5,7.21-4.21s5.24-3.33,7-4.51l2.11-1.41a4.24,4.24,0,0,1,.8-.48,3.5,3.5,0,0,1-.71.62c-.47.37-1.16.89-2,1.52-1.73,1.25-4.18,2.92-7,4.63s-5.39,3.13-7.29,4.11c-.95.49-1.73.87-2.28,1.12A3.72,3.72,0,0,1,434.64,330.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "444.7px 324.205px"
    },
    id: "el09alv4dca11w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.93,318.93a3.19,3.19,0,0,1,.78.37c.49.26,1.19.65,2.05,1.13,1.72,1,4.08,2.36,6.67,3.9s4.93,3,6.61,4c.84.52,1.51.95,2,1.26s.71.48.69.51a3.76,3.76,0,0,1-.78-.37c-.49-.26-1.19-.65-2.05-1.14-1.72-1-4.08-2.35-6.67-3.89s-4.93-3-6.61-4c-.84-.53-1.51-.95-2-1.26A3.15,3.15,0,0,1,415.93,318.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "425.331px 324.515px"
    },
    id: "elkisig7tbim",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.22,347.82a4.64,4.64,0,0,1,1,.48l2.63,1.45c2.21,1.24,5.25,3,8.59,4.92s6.36,3.73,8.53,5l2.56,1.57a4.5,4.5,0,0,1,.9.63,5.77,5.77,0,0,1-1-.48L432.8,360c-2.21-1.24-5.24-3-8.59-4.93s-6.35-3.72-8.52-5l-2.56-1.57A6,6,0,0,1,412.22,347.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "424.325px 354.845px"
    },
    id: "ell8yg5xlzfpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.94,361.4a6.44,6.44,0,0,1,1-.66l2.75-1.67c2.31-1.41,5.51-3.37,9-5.63s6.56-4.38,8.79-5.93l2.64-1.84a6.76,6.76,0,0,1,1-.63,6,6,0,0,1-.89.77c-.6.47-1.47,1.14-2.56,1.95-2.19,1.61-5.25,3.78-8.73,6s-6.7,4.19-9.06,5.53c-1.18.67-2.14,1.21-2.81,1.56A6.12,6.12,0,0,1,435.94,361.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "448.53px 353.22px"
    },
    id: "el3l0xtq6dqzx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.91 380.89 421.67 380.89 431.87 458.08 442.72 458.08 452.91 380.89",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "437.29px 419.485px"
    },
    id: "el28ew1l36rxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.29,390.38s0,.11.17.27a1.9,1.9,0,0,0,.75.54,3.8,3.8,0,0,0,3.3-.4c1.26-.7,2.36-2.07,4.05-2.67a8.88,8.88,0,0,1,5.75.11,25.09,25.09,0,0,1,5.35,2.6,38.24,38.24,0,0,0,4.35,2.33,12,12,0,0,0,3.21.93,5.6,5.6,0,0,0,.9.06c.21,0,.32,0,.32,0a15.88,15.88,0,0,1-4.28-1.29,42.57,42.57,0,0,1-4.26-2.41,24,24,0,0,0-5.44-2.67,9.2,9.2,0,0,0-6.06-.07,8,8,0,0,0-2.29,1.41,17.49,17.49,0,0,1-1.78,1.39,3.69,3.69,0,0,1-3.05.53A3.23,3.23,0,0,1,423.29,390.38Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "437.365px 390.691px"
    },
    id: "elpk4eanzw3x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.43,404.59s.25-.31.74-.82a6.93,6.93,0,0,1,2.49-1.59,11.23,11.23,0,0,1,4.35-.65,45,45,0,0,1,5.43.74,18.58,18.58,0,0,0,5.57.23,15.27,15.27,0,0,0,4.38-1.25,14,14,0,0,0,2.64-1.57,3.55,3.55,0,0,0,.83-.75,27.42,27.42,0,0,1-3.61,2A15.85,15.85,0,0,1,443,402a19.11,19.11,0,0,1-5.43-.26,39.27,39.27,0,0,0-5.51-.71,11,11,0,0,0-4.49.79,6.61,6.61,0,0,0-2.51,1.78,4.23,4.23,0,0,0-.47.7A.88.88,0,0,0,424.43,404.59Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "437.645px 401.76px"
    },
    id: "elyy1hytjv4ne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.37,412.21s-.27-.22-.86-.45a9.19,9.19,0,0,0-2.59-.56,16.5,16.5,0,0,0-3.91.23c-1.46.23-3,.64-4.66,1a19.58,19.58,0,0,1-4.65.53,10.12,10.12,0,0,1-3.7-.8,8.49,8.49,0,0,1-2.8-2.09,2.24,2.24,0,0,0,.53.82,6.63,6.63,0,0,0,2.12,1.6,10,10,0,0,0,3.83.94,18.84,18.84,0,0,0,4.78-.5c1.65-.35,3.2-.76,4.63-1a18,18,0,0,1,3.81-.33A14.16,14.16,0,0,1,449.37,412.21Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "437.785px 411.753px"
    },
    id: "elc2f60wlxd4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.19,422.91a5.11,5.11,0,0,1,3-.3,14,14,0,0,1,3.17,1.18,11.91,11.91,0,0,0,4.12,1.13,12.27,12.27,0,0,0,7.47-1.73,10.17,10.17,0,0,0,1.86-1.43c.38-.4.58-.64.55-.66a27,27,0,0,1-2.59,1.78,12.8,12.8,0,0,1-7.25,1.54c-2.95-.17-5.22-1.94-7.27-2.17a4.67,4.67,0,0,0-2.36.2A1.61,1.61,0,0,0,427.19,422.91Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "437.276px 423.035px"
    },
    id: "elbg01tx7duap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.93,437.73a6,6,0,0,0,2.61-.52c1.57-.53,3.51-1.73,5.78-2.63a9.42,9.42,0,0,1,3.32-.7,6.19,6.19,0,0,1,2.67.61,5.84,5.84,0,0,1,1.93,1.67,1.45,1.45,0,0,0-.29-.66,4.55,4.55,0,0,0-1.47-1.33,6.3,6.3,0,0,0-2.83-.76,9.36,9.36,0,0,0-3.51.69c-2.35.94-4.23,2.18-5.73,2.77S428.92,437.65,428.93,437.73Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "437.085px 435.571px"
    },
    id: "ela7fi55u02oh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.46,444.62a7.84,7.84,0,0,0,2,.64,36.92,36.92,0,0,0,4.95.84,35.89,35.89,0,0,0,5,.14,7.8,7.8,0,0,0,2.07-.24c0-.16-3.17,0-7-.41S430.5,444.47,430.46,444.62Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "437.47px 445.435px"
    },
    id: "elmklec4zysfq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "246px 458px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.14,458c0,.15-92.3.26-206.13.26S39.86,458.14,39.86,458s92.28-.26,206.15-.26S452.14,457.85,452.14,458Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "246px 458px"
    },
    id: "elt88hii2xga",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-2",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "393.25px 77.22px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elbed9an6s9ls"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 393.25,
    cy: 77.22,
    r: 41.84,
    style: {
      fill: "#68A1D6",
      transformOrigin: "393.25px 77.22px",
      transform: "rotate(-75.39deg)"
    },
    className: "animable",
    id: "elty0istntuy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhd5t71j05es"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "378.26px 52.8239px"
    },
    className: "animable",
    id: "elo9b64wtwv3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.76,36.71a41.85,41.85,0,0,0-51,30s28.13,8.65,37.95-1S403.76,36.71,403.76,36.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "378.26px 52.8239px"
    },
    id: "elteiknqc07ni",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M423.57,84.39a31.81,31.81,0,1,1-22.81-38.77A31.8,31.8,0,0,1,423.57,84.39Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "392.778px 76.4119px"
    },
    id: "ellrek5utp2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5cojqfllbe"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "392.778px 76.4119px"
    },
    className: "animable",
    id: "el1b1f8wr7wn5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.57,84.39a31.81,31.81,0,1,1-22.81-38.77A31.8,31.8,0,0,1,423.57,84.39Z",
    id: "el32xxp7nzbke",
    className: "animable",
    style: {
      transformOrigin: "392.778px 76.4119px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M424.11,85.9a31.38,31.38,0,1,1-22.5-38.25A31.39,31.39,0,0,1,424.11,85.9Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "393.733px 78.0256px"
    },
    id: "elfz2bu9120xv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elodoqwbi27p"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "393.733px 78.0256px"
    },
    className: "animable",
    id: "elcuaky3femd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.11,85.9a31.38,31.38,0,1,1-22.5-38.25A31.39,31.39,0,0,1,424.11,85.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "393.733px 78.0256px"
    },
    id: "elxlem28k6pw",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M395.62,75.71l2-7.77h0a16.65,16.65,0,0,1,3.86,2.15,13.77,13.77,0,0,1,1.62,1.72l.16-.21,1.92-2.49.45-.57-1-1.81-.74.12a15.18,15.18,0,0,0-5.21-3.08l1.1-4.27-1.05-1.42-.28,1.07-1.82-.47L395.54,63c-6.16-1-9.9,1.71-10.91,5.63-1.39,5.36,2.83,7.93,6.84,10.08l-2,7.7a15.22,15.22,0,0,1-6.94-4.92L379.79,85c1.55,2.25,4.89,4.43,8.6,5.64l-.84,3.23L386,93.46l1.24,1.41,3.16.82,1.12-4.31c6.2,1,10-1.69,11-5.62C403.94,80.41,399.63,77.85,395.62,75.71Zm-2.95-1.63c-2.06-1.23-3.5-2.51-3-4.36.44-1.69,2-2.78,4.8-2.49Zm5-6.15Zm-5,19.25,1.76-6.81c2.14,1.25,3.61,2.57,3.12,4.46C397.1,86.49,395.57,87.49,392.65,87.18Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "392.71px 76.885px"
    },
    id: "el1o6v1ecpa65",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxrs41a0hn5"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "392.71px 76.885px"
    },
    className: "animable",
    id: "elsyczkn245y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.62,75.71l2-7.77h0a16.65,16.65,0,0,1,3.86,2.15,13.77,13.77,0,0,1,1.62,1.72l.16-.21,1.92-2.49.45-.57-1-1.81-.74.12a15.18,15.18,0,0,0-5.21-3.08l1.1-4.27-1.05-1.42-.28,1.07-1.82-.47L395.54,63c-6.16-1-9.9,1.71-10.91,5.63-1.39,5.36,2.83,7.93,6.84,10.08l-2,7.7a15.22,15.22,0,0,1-6.94-4.92L379.79,85c1.55,2.25,4.89,4.43,8.6,5.64l-.84,3.23L386,93.46l1.24,1.41,3.16.82,1.12-4.31c6.2,1,10-1.69,11-5.62C403.94,80.41,399.63,77.85,395.62,75.71Zm-2.95-1.63c-2.06-1.23-3.5-2.51-3-4.36.44-1.69,2-2.78,4.8-2.49Zm5-6.15Zm-5,19.25,1.76-6.81c2.14,1.25,3.61,2.57,3.12,4.46C397.1,86.49,395.57,87.49,392.65,87.18Z",
    id: "elh7d54vngp2h",
    className: "animable",
    style: {
      transformOrigin: "392.71px 76.885px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M390.53,90l-1.12,4.31-3.16-.82,1.11-4.27c-3.72-1.21-7.05-3.4-8.61-5.65l2.74-3.44a15.32,15.32,0,0,0,6.95,4.93l2-7.71c-4-2.14-8.22-4.72-6.84-10.07,1-3.93,4.76-6.62,10.92-5.64l1.13-4.35,3.15.82-1.1,4.27a17.07,17.07,0,0,1,7.21,4.38l-2.59,3.48a16.51,16.51,0,0,0-5.7-3.7l-2,7.78c4,2.15,8.32,4.7,6.93,10.06C400.5,88.3,396.73,90.94,390.53,90Zm1.11-17.31,1.78-6.85c-2.84-.29-4.36.8-4.8,2.49C388.14,70.17,389.58,71.45,391.64,72.68Zm4.86,10.76c.49-1.89-1-3.22-3.12-4.47l-1.76,6.82C394.54,86.09,396.07,85.09,396.5,83.44Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "391.83px 75.8px"
    },
    id: "ela883spd22mk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.22,108.56a1.15,1.15,0,0,1,.25,0l.75.13,1.21.24a12.92,12.92,0,0,0,1.66.26l2.09.2a9.5,9.5,0,0,0,1.2,0h1.3a13,13,0,0,0,1.39,0l1.48-.15c.5-.06,1-.08,1.56-.18l1.62-.32a33.39,33.39,0,0,0,7-2.31l1.79-.94c.3-.16.61-.31.92-.49l.88-.57c.58-.4,1.2-.76,1.78-1.2l1.73-1.37.44-.35.4-.39.82-.8.83-.8c.28-.26.51-.58.77-.87.5-.6,1-1.18,1.51-1.81l1.37-2a34,34,0,0,0,4-9.15,34,34,0,0,0,.93-10l-.24-2.4c-.11-.78-.29-1.55-.44-2.32a11,11,0,0,0-.25-1.14l-.33-1.1-.33-1.09c-.06-.18-.1-.36-.17-.54l-.21-.52q-.42-1-.84-2c-.3-.66-.66-1.28-1-1.91-.17-.31-.33-.62-.49-.93s-.38-.58-.56-.87L419,59.23a33.3,33.3,0,0,0-5-5.41l-1.26-1.07c-.42-.34-.87-.61-1.28-.91L410.22,51c-.38-.28-.81-.47-1.19-.7l-1.14-.63a7.76,7.76,0,0,0-1.07-.55l-1.93-.84a11.11,11.11,0,0,0-1.57-.58l-1.17-.38-.72-.24-.25-.1.25.06.73.22,1.19.35a12.87,12.87,0,0,1,1.59.56l1.94.81a9.18,9.18,0,0,1,1.09.54l1.14.63a12.55,12.55,0,0,1,1.21.7l1.24.84c.41.29.87.56,1.29.91l1.27,1.06a34.19,34.19,0,0,1,5.06,5.43l1.12,1.7c.19.29.39.58.57.88l.5.94c.33.63.69,1.26,1,1.92s.56,1.37.85,2.06l.21.52c.07.18.12.37.17.55l.34,1.1c.11.37.22.74.34,1.11s.16.76.25,1.15c.15.77.33,1.55.45,2.34l.24,2.42a34,34,0,0,1-.93,10.06,34.39,34.39,0,0,1-4.07,9.24l-1.39,2c-.49.64-1,1.22-1.53,1.83-.26.29-.49.61-.78.88l-.83.8-.83.8c-.14.13-.27.27-.41.39l-.45.36-1.74,1.38c-.59.44-1.22.8-1.81,1.2l-.89.58c-.3.17-.62.32-.92.49l-1.81.94a33.17,33.17,0,0,1-7.06,2.28l-1.63.32c-.53.1-1.06.11-1.57.17l-1.49.13a13,13,0,0,1-1.39,0h-1.31a8,8,0,0,1-1.21,0l-2.1-.23a12.58,12.58,0,0,1-1.66-.29l-1.2-.26-.74-.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "405.248px 78.3164px"
    },
    id: "el5me322ie8j3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.83,87.28a2.2,2.2,0,0,1-.1-.36c-.07-.28-.15-.63-.25-1.06a16.14,16.14,0,0,1-.33-1.68c-.1-.66-.25-1.41-.31-2.25,0-.42-.08-.86-.13-1.31s0-.94-.06-1.43c-.07-1,0-2,0-3.16a41.6,41.6,0,0,1,3.07-14.09c.44-1,.84-2,1.31-2.87.23-.44.43-.88.66-1.28l.66-1.14c.4-.74.85-1.36,1.21-1.92s.71-1,1-1.39l.66-.86c.16-.19.24-.29.25-.28a1.39,1.39,0,0,1-.2.32l-.61.89c-.28.38-.61.85-.95,1.42s-.78,1.19-1.17,1.93c-.2.37-.42.75-.64,1.15s-.42.83-.64,1.27c-.45.87-.84,1.85-1.28,2.87a48,48,0,0,0-2.11,6.87,46.43,46.43,0,0,0-.93,7.12c0,1.11-.08,2.16,0,3.14,0,.49,0,1,.05,1.42s.08.89.11,1.31c.05.84.18,1.59.26,2.25s.18,1.22.28,1.68.14.79.19,1.06A1.56,1.56,0,0,1,353.83,87.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "357.044px 69.7397px"
    },
    id: "elinqq37mifm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.39,71.17a2.74,2.74,0,0,1-.66-1.12,5,5,0,0,1-.12-3.14,5.1,5.1,0,0,1,1.81-2.57,2.64,2.64,0,0,1,1.17-.57s-.43.24-1,.75A5.06,5.06,0,0,0,384.94,70C385.16,70.73,385.44,71.14,385.39,71.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "386.002px 67.47px"
    },
    id: "el9cr1tcvsi5u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.32,61.16a3,3,0,0,1,.18-1.3,2.93,2.93,0,0,1,.48-1.23,3,3,0,0,1-.18,1.3C395.62,60.63,395.41,61.18,395.32,61.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "395.65px 59.8953px"
    },
    id: "elcffhqtzhv7h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.75,45.55a6.56,6.56,0,0,1-1-.3c-.31-.11-.69-.23-1.14-.35s-.95-.3-1.53-.42-1.19-.29-1.87-.4-1.41-.23-2.17-.34a32.87,32.87,0,0,0-10,.35c-.76.16-1.48.29-2.15.48s-1.28.36-1.84.54-1.05.36-1.49.52-.81.3-1.11.43a6.41,6.41,0,0,1-1,.36,6.67,6.67,0,0,1,.91-.47,11.22,11.22,0,0,1,1.1-.49c.43-.17.92-.39,1.48-.56s1.17-.4,1.85-.58,1.39-.35,2.15-.52a34.66,34.66,0,0,1,5-.59,35.55,35.55,0,0,1,5.07.24c.78.12,1.51.22,2.19.37s1.31.29,1.88.45,1.08.32,1.52.46a11.45,11.45,0,0,1,1.13.41A5.85,5.85,0,0,1,403.75,45.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "391.1px 44.8098px"
    },
    id: "elpzjv8zagglk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.23,116.91a4.21,4.21,0,0,1-.77,0c-.5,0-1.22-.07-2.1-.18a30.23,30.23,0,0,1-12.93-4.81c-.74-.5-1.32-.93-1.71-1.24a4.14,4.14,0,0,1-.57-.51,3.74,3.74,0,0,1,.65.41c.4.29,1,.68,1.75,1.15a34.33,34.33,0,0,0,6.17,3.05,34,34,0,0,0,6.67,1.73c.87.14,1.58.23,2.08.27A4.14,4.14,0,0,1,388.23,116.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "379.19px 113.549px"
    },
    id: "elrk1pxjwzue9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.76,87.72s0-.23.14-.67.26-1.08.41-1.94A43.18,43.18,0,0,0,435,77.5a40.94,40.94,0,0,0-.35-5.51,40.16,40.16,0,0,0-1.34-6.43,42.32,42.32,0,0,0-7.3-14.14,40.65,40.65,0,0,0-6.52-6.61A41.17,41.17,0,0,0,411,39.47a41.67,41.67,0,0,0-10.27-3.27,42.78,42.78,0,0,0-5.61-.65,43.28,43.28,0,0,0-5.79.15,41.77,41.77,0,0,0-27.08,13.65,39.74,39.74,0,0,0-4,5.2A41.65,41.65,0,0,0,351.66,80c.06,1.1.21,2.19.34,3.27s.36,2.15.62,3.21a41.65,41.65,0,0,0,17,25.09,43,43,0,0,0,5,2.94,42.39,42.39,0,0,0,15.77,4.29,41.64,41.64,0,0,0,19-3.13,42.32,42.32,0,0,0,13.25-8.82,40.1,40.1,0,0,0,4.29-5,39.23,39.23,0,0,0,3-4.65,41.61,41.61,0,0,0,3.06-7c.29-.82.45-1.48.59-1.9s.2-.65.2-.65-.21.9-.73,2.57a41.83,41.83,0,0,1-3,7,41,41,0,0,1-3,4.68,40.2,40.2,0,0,1-4.29,5,42.29,42.29,0,0,1-13.29,8.89,42.31,42.31,0,0,1-35-1.1,43.53,43.53,0,0,1-5-3,42.18,42.18,0,0,1-17.18-25.26c-.25-1.07-.43-2.15-.62-3.23s-.28-2.19-.34-3.3A42,42,0,0,1,358,54.38a38.94,38.94,0,0,1,4-5.23,41.32,41.32,0,0,1,4.7-4.48,42.12,42.12,0,0,1,22.58-9.26,45.78,45.78,0,0,1,5.84-.14,43.24,43.24,0,0,1,5.64.66,41.76,41.76,0,0,1,10.33,3.31,41.68,41.68,0,0,1,15.11,12,42.44,42.44,0,0,1,7.3,14.24A40.22,40.22,0,0,1,434.84,72a41,41,0,0,1-.47,13.15C434,86.83,433.76,87.72,433.76,87.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "393.203px 77.1427px"
    },
    id: "elu6c39hokn7",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-2",
    className: "animable",
    style: {
      transformOrigin: "248.824px 255.07px"
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "309.94 447.14 126.81 447.14 126.81 96.1 372.04 96.1 372.04 384.37",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "249.425px 271.62px"
    },
    id: "ellvro0jvhbe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,384.37s0-.46,0-1.35,0-2.24,0-4c0-3.53,0-8.74,0-15.54,0-13.61,0-33.53-.07-58.82,0-50.59,0-122.66-.09-208.57l.23.23-245.23,0,.26-.26v.31c0,134.94,0,258.18-.06,350.73l-.2-.2,133.88.09,36.51.05,9.5,0,3.24,0-3.24,0-9.5,0-36.51.06-133.88.08h-.19v-.19c0-92.55,0-215.79-.07-350.73v-.57h.26l245.23,0h.23v.23c0,85.91-.07,158-.1,208.57,0,25.29,0,45.21-.06,58.82,0,6.8,0,12,0,15.54,0,1.75,0,3.09,0,4S372,384.37,372,384.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "249.44px 271.435px"
    },
    id: "elqcyhb786zne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.32,
    y: 117.87,
    width: 107.11,
    height: 57.74,
    style: {
      fill: "#68A1D6",
      transformOrigin: "195.875px 146.74px"
    },
    id: "el13lmbdequihn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.51,131.2c0,.15-19.26.27-43,.27s-43-.12-43-.27,19.25-.26,43-.26S352.51,131.06,352.51,131.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "309.51px 131.205px"
    },
    id: "ellga5p0rudn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.51,141.56c0,.14-19.26.26-43,.26s-43-.12-43-.26,19.25-.26,43-.26S352.51,141.42,352.51,141.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "309.51px 141.56px"
    },
    id: "el2zwwnd0mlf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.51,151.92c0,.14-19.26.26-43,.26s-43-.12-43-.26,19.25-.26,43-.26S352.51,151.77,352.51,151.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "309.51px 151.92px"
    },
    id: "elyjhxr13uq5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.28,162.27c0,.15-11.6.26-25.9.26s-25.89-.11-25.89-.26,11.59-.26,25.89-.26S318.28,162.13,318.28,162.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "292.385px 162.27px"
    },
    id: "elh3apbffjq8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.79,187.29c0,.14-47.53.26-106.14.26s-106.14-.12-106.14-.26S191,187,249.65,187,355.79,187.15,355.79,187.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "249.65px 187.275px"
    },
    id: "el1vts8v22izp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.79,193.67c0,.14-47,.26-105,.26s-105-.12-105-.26,47-.26,105-.26S355.79,193.53,355.79,193.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.79px 193.67px"
    },
    id: "elu1gibozyqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.51,
    y: 203.96,
    width: 212.28,
    height: 12.32,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "249.65px 210.12px"
    },
    id: "el9nm8g0avvzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.22,
    y: 316.87,
    width: 212.28,
    height: 12.32,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "247.36px 323.03px"
    },
    id: "elhlsaenlmtdv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.51,
    y: 256.2,
    width: 84.66,
    height: 12.32,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "185.84px 262.36px"
    },
    id: "el3sv5344s38c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.65,
    y: 256.2,
    width: 105.85,
    height: 12.32,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "300.575px 262.36px"
    },
    id: "elstglf3ude8c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.16,227.17c0,.14-27.24.26-60.84.26s-60.84-.12-60.84-.26,27.23-.27,60.84-.27S266.16,227,266.16,227.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "205.32px 227.165px"
    },
    id: "elw64dhyt14it",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6,236.86c0,.14-47.09.26-105.17.26s-105.18-.12-105.18-.26,47.08-.26,105.18-.26S354.6,236.71,354.6,236.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "249.425px 236.86px"
    },
    id: "elyn208au2os9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6,246c0,.14-47.09.26-105.17.26s-105.18-.12-105.18-.26,47.08-.26,105.18-.26S354.6,245.9,354.6,246Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "249.425px 246px"
    },
    id: "el0dkwgp4igr2q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.43,276c0,.14-18.94.26-42.29.26s-42.3-.12-42.3-.26,18.93-.26,42.3-.26S227.43,275.89,227.43,276Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "185.135px 276px"
    },
    id: "elu6kiaodkc5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.43,285.5c0,.14-18.62.26-41.59.26s-41.6-.12-41.6-.26,18.62-.26,41.6-.26S227.43,285.35,227.43,285.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "185.835px 285.5px"
    },
    id: "elgsyw10ryt2s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.09,295.11c0,.15-18.79.26-42,.26s-42-.11-42-.26,18.78-.26,42-.26S227.09,295,227.09,295.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "185.09px 295.11px"
    },
    id: "elqil7kmzl8z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.09,304.45c0,.14-18.79.26-42,.26s-42-.12-42-.26,18.78-.26,42-.26S227.09,304.3,227.09,304.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "185.09px 304.45px"
    },
    id: "el9jyrw3txwb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.87,278.25c0,.15-19.61.26-43.8.26s-43.81-.11-43.81-.26,19.61-.26,43.81-.26S351.87,278.11,351.87,278.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "308.065px 278.25px"
    },
    id: "el3xgbqtqntoo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.53,281.27a12.31,12.31,0,0,1-.11-1.73c0-1.06-.09-2.54-.12-4.3l.23.22-6,0,.26-.26h0v3.17c0,1,0,1.95,0,2.84l-.22-.22c1.76,0,3.23.07,4.3.11a14.76,14.76,0,0,1,1.73.11,9.76,9.76,0,0,1-1.59.11c-1.05,0-2.59.09-4.44.12h-.23v-.23c0-.89,0-1.84,0-2.84v-3.17h0c-.23.23.32-.32.27-.26l6,0h.23v.23c0,1.86-.07,3.39-.11,4.44A9.76,9.76,0,0,1,257.53,281.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "254.562px 278.188px"
    },
    id: "eln2v9p8qtnxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.87,289.84c0,.15-19.61.26-43.8.26s-43.81-.11-43.81-.26,19.61-.26,43.81-.26S351.87,289.7,351.87,289.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "308.065px 289.84px"
    },
    id: "elwl5mi68c90b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.53,292.86a12.31,12.31,0,0,1-.11-1.73c0-1.07-.09-2.54-.12-4.3l.23.22-6,0,.26-.26h0V290q0,1.51,0,2.85l-.22-.23c1.76,0,3.23.08,4.3.12a14.76,14.76,0,0,1,1.73.11,9.76,9.76,0,0,1-1.59.11c-1.05,0-2.59.09-4.44.11h-.23v-.23q0-1.33,0-2.85v-3.16h0c-.23.23.32-.32.27-.26l6,0h.23v.23c0,1.86-.07,3.39-.11,4.44A9.76,9.76,0,0,1,257.53,292.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "254.562px 289.818px"
    },
    id: "elzfrmdhxvnni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.87,301.43c0,.15-19.61.26-43.8.26s-43.81-.11-43.81-.26,19.61-.26,43.81-.26S351.87,301.29,351.87,301.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "308.065px 301.43px"
    },
    id: "elezak6srx2f7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.53,304.45a12.49,12.49,0,0,1-.11-1.73c0-1.07-.09-2.55-.12-4.3l.23.22-6,0,.26-.26h0v3.16q0,1.51,0,2.85l-.22-.23c1.76,0,3.23.08,4.3.12a12.49,12.49,0,0,1,1.73.11,9.76,9.76,0,0,1-1.59.11c-1.05,0-2.59.09-4.44.11h-.23v-.23q0-1.33,0-2.85v-3.16h0l.27-.27,6,0h.23v.23c0,1.85-.07,3.39-.11,4.44A9.76,9.76,0,0,1,257.53,304.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "254.59px 301.355px"
    },
    id: "el0xxipl3fuxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.87,397.25s0-.34,0-1,0-1.62,0-2.88c0-2.55,0-6.3,0-11.18,0-9.75-.05-24-.09-42l.16.16-209,.1h0l.26-.26c0,19.63,0,38.77,0,57.06l-.25-.25,149.28.11,43.85.07,11.79,0h3.06l1,0-1,0h-3l-11.74,0-43.78.07-149.46.12h-.26V339.93h.27l209,.1H352v.16c0,18.05-.06,32.33-.08,42.11,0,4.86,0,8.6,0,11.14,0,1.25,0,2.2,0,2.85S351.87,397.25,351.87,397.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "247.345px 368.65px"
    },
    id: "el02ab85v0xmrq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.87,354.55c0,.14-46.66.26-104.21.26s-104.23-.12-104.23-.26,46.66-.26,104.23-.26S351.87,354.4,351.87,354.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "247.65px 354.55px"
    },
    id: "elszl270h3zj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.87,368.72c0,.14-46.66.26-104.21.26s-104.23-.12-104.23-.26,46.66-.26,104.23-.26S351.87,368.57,351.87,368.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "247.65px 368.72px"
    },
    id: "elrjabloz39ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.87,383c0,.15-46.66.26-104.21.26s-104.23-.11-104.23-.26,46.66-.26,104.23-.26S351.87,382.9,351.87,383Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "247.65px 383px"
    },
    id: "el4rx5c3dr3go",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14,397.75c-.14,0-.26-12.91-.26-28.83s.12-28.83.26-28.83.27,12.91.27,28.83S167.29,397.75,167.14,397.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.145px 368.92px"
    },
    id: "elw8344xiobm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.83,396c-.15,0-.26-12.33-.26-27.53s.11-27.53.26-27.53.26,12.32.26,27.53S238,396,237.83,396Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.83px 368.47px"
    },
    id: "eleksl183d5f7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.31,398.62c-.15,0-.26-12.72-.26-28.4s.11-28.39.26-28.39.26,12.71.26,28.39S312.45,398.62,312.31,398.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "312.31px 370.225px"
    },
    id: "elyyzvemnlyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.94 447.14 372.04 384.37 309.94 384.37 309.94 447.14",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "340.99px 415.755px"
    },
    id: "elndxnq3o80u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.94,447.14c0-2.1-.09-25.95-.23-62.77v-.24h.23l43.81,0h18.9l-.43.44L327.74,429.3l-17.8,17.84L327.77,429l44.09-44.78.18.43H353.75l-43.81,0,.24-.23C310,421.19,310,445,309.94,447.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "341.18px 415.635px"
    },
    id: "elth5l168c71c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.87,410c0,.14-36.49.26-81.51.26s-81.52-.12-81.52-.26,36.49-.26,81.52-.26S306.87,409.9,306.87,410Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.355px 410px"
    },
    id: "elf0a4d7zlveb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.87,418.29c0,.14-36.49.26-81.51.26s-81.52-.12-81.52-.26,36.49-.26,81.52-.26S306.87,418.14,306.87,418.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.355px 418.29px"
    },
    id: "elgnbblfmwoc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,426.54c0,.14-16.61.26-37.09.26s-37.1-.12-37.1-.26,16.61-.26,37.1-.26S218,426.39,218,426.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "180.905px 426.54px"
    },
    id: "el0kfo38vt8e7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,138.44h-9.37V134h24v4.44h-9.37v23.83h-5.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "169.54px 148.135px"
    },
    id: "ela0r5kdyq5ok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.41,155.73H188.27l-2.78,6.54h-5.42L192.8,134H198l12.76,28.27h-5.49Zm-1.74-4.12-5.33-12.36-5.29,12.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "195.415px 148.135px"
    },
    id: "elmuc8tassc8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.72,162.27l-7.67-10.74-7.6,10.74h-6L220,147.85,210,134H216l7.23,10.06L230.36,134h5.69l-9.9,13.65,10.63,14.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "223.115px 148.135px"
    },
    id: "el03hy3csfer59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.74,108.32c0,.14-48.21.26-107.67.26s-107.67-.12-107.67-.26,48.2-.26,107.67-.26S357.74,108.18,357.74,108.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "250.07px 108.32px"
    },
    id: "eltykr2uxfzt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.81,112.24c0,.14-24.27.26-54.21.26s-54.2-.12-54.2-.26,24.26-.26,54.2-.26S250.81,112.09,250.81,112.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "196.605px 112.24px"
    },
    id: "elxvbojtehb3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.19,
    y: 75.49,
    width: 269.24,
    height: 382.15,
    rx: 10.88,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "248.81px 266.565px"
    },
    id: "elo5b70a1nms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.55,457.63l.84-.05a12.36,12.36,0,0,0,2.42-.47,11.28,11.28,0,0,0,3.56-1.93,11,11,0,0,0,3.26-4.5,10.2,10.2,0,0,0,.71-3.29c.06-1.19,0-2.45,0-3.77,0-2.64,0-5.52,0-8.65,0-6.25,0-13.47,0-21.59,0-32.5-.05-79.51-.08-137.6,0-29,0-60.86,0-95q0-25.6,0-52.93V100.15q0-7,0-14.12a10.58,10.58,0,0,0-8.27-10,14.28,14.28,0,0,0-3.53-.27H125.1a10.62,10.62,0,0,0-10.62,10.09c0,5.48,0,11,0,16.46v96.36c0,41.81,0,82.13,0,120.54s0,74.9,0,109.06q0,6.4,0,12.7c0,2.09,0,4.2,0,6.26a10.5,10.5,0,0,0,1.93,5.68,10.81,10.81,0,0,0,4.64,3.72,11.66,11.66,0,0,0,2.9.74c1,.09,2,.07,3,.07h12l45.6,0,137.58.08,37.41.05,9.73,0c2.19,0,3.31,0,3.31,0l-3.31,0-9.73,0-37.41.05-137.58.09H126.91c-1,0-2,0-3.06-.07a11.93,11.93,0,0,1-3-.77,11.18,11.18,0,0,1-4.83-3.86,11,11,0,0,1-2-5.91c-.05-2.09,0-4.17,0-6.27v-12.7c0-34.16,0-70.66,0-109.06s0-78.73,0-120.54q0-31.35,0-63.75V102.3c0-5.48,0-11,0-16.49A11.15,11.15,0,0,1,125.1,75.22H371.38a15.47,15.47,0,0,1,3.64.29A11.06,11.06,0,0,1,383.65,86q0,7.13,0,14.14,0,14,0,27.68,0,27.29,0,52.93c0,34.16,0,66,0,95,0,58.09-.07,105.1-.09,137.6,0,8.12,0,15.34,0,21.59q0,4.69,0,8.65c0,1.32,0,2.58,0,3.78a10.67,10.67,0,0,1-.73,3.32,11,11,0,0,1-3.31,4.52,10.52,10.52,0,0,1-6,2.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "248.824px 266.459px"
    },
    id: "elqofdgp5nf0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhmv8vzf7ftw"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "249.425px 412.99px"
    },
    className: "animable",
    id: "elcc3xbfmrozd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "137.68 449 317.82 449 361.17 402 361.17 376.98 137.68 411.9 137.68 449",
    id: "elzlzzs7zh62",
    className: "animable",
    style: {
      transformOrigin: "249.425px 412.99px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ell8klexsyk"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "318.99px 87.615px"
    },
    className: "animable",
    id: "elj9jolamzvg"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "316.75 76.27 321.88 91.5 321.88 98.96 316.1 98.96 316.75 76.27",
    id: "el9v12e36ev1",
    className: "animable",
    style: {
      transformOrigin: "318.99px 87.615px"
    }
  }))), /*#__PURE__*/React.createElement("polyline", {
    points: "309.33 441.84 126.2 441.84 126.2 90.8 371.42 90.8 371.42 379.07",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "248.81px 266.32px"
    },
    id: "ela39hwskgvql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.42,379.07s0-.46,0-1.35,0-2.24,0-4c0-3.53,0-8.74,0-15.54,0-13.61,0-33.53-.06-58.82,0-50.59-.06-122.66-.1-208.57l.23.23-245.22,0,.26-.26v.31c0,134.94,0,258.18-.06,350.73l-.2-.2,133.88.09,36.5,0,9.51,0,3.24,0s-1.1,0-3.24,0l-9.51,0-36.5.06L126.2,442H126v-.19c0-92.55,0-215.79-.06-350.73v-.57h.26l245.22,0h.23v.23c0,85.91-.07,158-.09,208.57,0,25.29-.05,45.21-.06,58.82,0,6.8,0,12,0,15.54,0,1.75,0,3.09,0,4S371.42,379.07,371.42,379.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "248.795px 266.255px"
    },
    id: "elwohe2x71m7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.71,
    y: 112.57,
    width: 107.11,
    height: 57.74,
    style: {
      fill: "#68A1D6",
      transformOrigin: "195.265px 141.44px"
    },
    id: "elcxlhkeyopqu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.89,125.9c0,.15-19.26.26-43,.26s-43-.11-43-.26,19.26-.26,43-.26S351.89,125.76,351.89,125.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "308.89px 125.9px"
    },
    id: "elf7ktl2zvzgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.89,136.26c0,.14-19.26.26-43,.26s-43-.12-43-.26,19.26-.26,43-.26S351.89,136.12,351.89,136.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "308.89px 136.26px"
    },
    id: "el27m5mbte8nr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.89,146.62c0,.14-19.26.26-43,.26s-43-.12-43-.26,19.26-.26,43-.26S351.89,146.47,351.89,146.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "308.89px 146.62px"
    },
    id: "eljbhdx0fw9sr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.66,157c0,.15-11.59.26-25.89.26s-25.9-.11-25.9-.26,11.6-.26,25.9-.26S317.66,156.83,317.66,157Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "291.765px 157px"
    },
    id: "elq39j14u6qs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.17,182c0,.14-47.52.26-106.13.26s-106.15-.12-106.15-.26,47.52-.26,106.15-.26S355.17,181.84,355.17,182Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "249.03px 182px"
    },
    id: "elmtc838rbe6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.17,188.37c0,.14-47,.26-105,.26s-105-.12-105-.26,47-.26,105-.26S355.17,188.23,355.17,188.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.17px 188.37px"
    },
    id: "el36ywnx9j7tj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.89,
    y: 198.66,
    width: 212.28,
    height: 12.32,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "249.03px 204.82px"
    },
    id: "elxr27xz24y5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.61,
    y: 311.57,
    width: 212.28,
    height: 12.32,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "246.75px 317.73px"
    },
    id: "eljcdrlx1znhm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.89,
    y: 250.9,
    width: 84.66,
    height: 12.32,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "185.22px 257.06px"
    },
    id: "elpvjotiheu6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.04,
    y: 250.9,
    width: 105.85,
    height: 12.32,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "299.965px 257.06px"
    },
    id: "elqrolcsl88j7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.55,221.86c0,.15-27.24.27-60.84.27s-60.85-.12-60.85-.27,27.24-.26,60.85-.26S265.55,221.72,265.55,221.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "204.705px 221.865px"
    },
    id: "el0dwrxqibbp7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,231.56c0,.14-47.09.26-105.17.26s-105.19-.12-105.19-.26,47.09-.26,105.19-.26S354,231.41,354,231.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "248.82px 231.56px"
    },
    id: "elspq2wuoep2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,240.74c0,.14-47.09.26-105.17.26s-105.19-.12-105.19-.26,47.09-.26,105.19-.26S354,240.6,354,240.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "248.82px 240.74px"
    },
    id: "elxkb7nc5xhta",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.82,270.74c0,.14-18.94.26-42.3.26s-42.3-.12-42.3-.26,18.94-.27,42.3-.27S226.82,270.59,226.82,270.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "184.52px 270.735px"
    },
    id: "el09o5rigmggoc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.82,280.2c0,.14-18.63.26-41.59.26s-41.6-.12-41.6-.26,18.62-.26,41.6-.26S226.82,280.05,226.82,280.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "185.225px 280.2px"
    },
    id: "elb4865c9ajzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.47,289.81c0,.15-18.78.26-41.95.26s-42-.11-42-.26,18.78-.26,42-.26S226.47,289.67,226.47,289.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "184.495px 289.81px"
    },
    id: "el8ok6d9qwjpk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.47,299.15c0,.14-18.78.26-41.95.26s-42-.12-42-.26,18.78-.26,42-.26S226.47,299,226.47,299.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "184.495px 299.15px"
    },
    id: "elb3rvlwtq0mo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.26,273c0,.15-19.62.26-43.81.26s-43.81-.11-43.81-.26,19.61-.26,43.81-.26S351.26,272.81,351.26,273Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "307.45px 273px"
    },
    id: "ely6ylmq0951",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.91,276s-.06-.67-.11-1.73-.09-2.54-.11-4.3l.22.22-6,0,.26-.26h0v1.61c0,.53,0,1.05,0,1.55,0,1,0,2,0,2.85l-.23-.22c1.76,0,3.24.07,4.3.11a14.52,14.52,0,0,1,1.73.11,9.37,9.37,0,0,1-1.58.11c-1.05,0-2.59.09-4.45.12h-.22V276q0-1.34,0-2.85c0-.5,0-1,0-1.55V270h0l.26-.26,6,0h.23v.23c0,1.86-.07,3.39-.12,4.44A8.46,8.46,0,0,1,256.91,276Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "253.965px 272.955px"
    },
    id: "elbdnzem9glt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.26,284.54c0,.15-19.62.26-43.81.26s-43.81-.11-43.81-.26,19.61-.26,43.81-.26S351.26,284.4,351.26,284.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "307.45px 284.54px"
    },
    id: "elcxsuvictosi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.91,287.56s-.06-.67-.11-1.73-.09-2.54-.11-4.3l.22.22-6,0c-.06,0,.49-.5.26-.26h0v1.6c0,.53,0,1.06,0,1.56,0,1,0,2,0,2.85l-.23-.23c1.76,0,3.24.08,4.3.12a14.52,14.52,0,0,1,1.73.11,9.37,9.37,0,0,1-1.58.11c-1.05,0-2.59.09-4.45.11h-.22v-.23q0-1.33,0-2.85c0-.5,0-1,0-1.56v-1.6h0l.26-.26,6,0h.23v.23c0,1.86-.07,3.39-.12,4.44A8.46,8.46,0,0,1,256.91,287.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "253.965px 284.47px"
    },
    id: "el1jufu51pl8ah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.26,296.13c0,.15-19.62.26-43.81.26s-43.81-.11-43.81-.26,19.61-.26,43.81-.26S351.26,296,351.26,296.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "307.45px 296.13px"
    },
    id: "elrmjno63xdub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.91,299.15s-.06-.67-.11-1.73-.09-2.55-.11-4.31l.22.23-6,0,.26-.26h0v1.6c0,.53,0,1.05,0,1.56,0,1,0,2,0,2.85l-.23-.23c1.76,0,3.24.08,4.3.12a12.31,12.31,0,0,1,1.73.11,9.37,9.37,0,0,1-1.58.11c-1.05,0-2.59.09-4.45.11h-.22v-.23q0-1.33,0-2.85c0-.51,0-1,0-1.56v-1.6h0c-.23.23.32-.32.26-.27l6,0h.23v.22c0,1.86-.07,3.4-.12,4.45A8.46,8.46,0,0,1,256.91,299.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "253.937px 296.053px"
    },
    id: "elm8xj09t5zmp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.26,392s0-.34,0-1,0-1.62,0-2.88c0-2.55,0-6.3,0-11.18,0-9.75-.05-24-.09-42l.16.16-209,.1h0l.26-.26V392l-.26-.25,149.28.11,43.85.07,11.79,0h3.06l1.05,0-1,0h-3l-11.74,0-43.79.07-149.46.11H142V392c0-18.29,0-37.43,0-57.06v-.26h.28l209,.1h.16v.16c0,18.05-.07,32.33-.09,42.11,0,4.86,0,8.6,0,11.14,0,1.25,0,2.2,0,2.85S351.26,392,351.26,392Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "246.72px 363.395px"
    },
    id: "elg43ertm1zji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.26,349.25c0,.14-46.66.26-104.22.26s-104.22-.12-104.22-.26S189.47,349,247,349,351.26,349.1,351.26,349.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "247.04px 349.255px"
    },
    id: "elv67vtfqkfo9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.26,363.42c0,.14-46.66.26-104.22.26s-104.22-.12-104.22-.26,46.65-.26,104.22-.26S351.26,363.27,351.26,363.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "247.04px 363.42px"
    },
    id: "elh7vw9s0d5z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.26,377.74c0,.15-46.66.26-104.22.26s-104.22-.11-104.22-.26,46.65-.26,104.22-.26S351.26,377.6,351.26,377.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "247.04px 377.74px"
    },
    id: "elosmglbduiqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.53,392.45c-.14,0-.26-12.91-.26-28.83s.12-28.83.26-28.83.26,12.91.26,28.83S166.67,392.45,166.53,392.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "166.53px 363.62px"
    },
    id: "elcct8bfrl2ak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.21,390.72c-.14,0-.26-12.33-.26-27.53s.12-27.53.26-27.53.26,12.32.26,27.53S237.36,390.72,237.21,390.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.21px 363.19px"
    },
    id: "elsgy0fd4ptpc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.69,393.32c-.14,0-.26-12.72-.26-28.4s.12-28.39.26-28.39.26,12.71.26,28.39S311.84,393.32,311.69,393.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "311.69px 364.925px"
    },
    id: "elwcbblsudqx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.33 441.84 371.42 379.07 309.33 379.07 309.33 441.84",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "340.375px 410.455px"
    },
    id: "elmkpho4ksbfl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.33,441.84c0-2.1-.1-25.95-.24-62.77v-.24h.24l43.8,0H372l-.43.44L327.12,424l-17.79,17.84,17.82-18.17,44.09-44.78.18.43H353.13l-43.8,0,.24-.23C309.43,415.89,309.34,439.74,309.33,441.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "340.545px 410.335px"
    },
    id: "elwfn53rmxx2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.26,404.74c0,.14-36.5.26-81.51.26s-81.52-.12-81.52-.26,36.49-.26,81.52-.26S306.26,404.6,306.26,404.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "224.745px 404.74px"
    },
    id: "elxml4a437h7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.26,413c0,.14-36.5.26-81.51.26s-81.52-.12-81.52-.26,36.49-.26,81.52-.26S306.26,412.84,306.26,413Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "224.745px 413px"
    },
    id: "elu112xzq43c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.42,421.24c0,.14-16.61.26-37.1.26s-37.09-.12-37.09-.26,16.6-.26,37.09-.26S217.42,421.09,217.42,421.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "180.325px 421.24px"
    },
    id: "elji4r2aqwu4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.3,133.14h-9.37V128.7h24v4.44h-9.37V157H166.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "168.93px 142.85px"
    },
    id: "elkuvs58seigo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.8,150.43H187.66L184.87,157h-5.41l12.72-28.27h5.17L210.12,157h-5.5Zm-1.74-4.12L194.73,134l-5.29,12.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "194.79px 142.865px"
    },
    id: "ellnj4kgvupxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.11,157l-7.68-10.74L214.84,157h-6l10.5-14.42-9.93-13.85h5.93l7.23,10.06,7.15-10.06h5.7l-9.9,13.65L236.16,157Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "222.5px 142.865px"
    },
    id: "eleo51h64jh6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.13,103c0,.14-48.21.26-107.67.26s-107.68-.12-107.68-.26,48.2-.26,107.68-.26S357.13,102.88,357.13,103Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "249.455px 103px"
    },
    id: "elz2sbnp0vhn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19,106.94c0,.14-24.27.26-54.2.26s-54.21-.12-54.21-.26,24.27-.26,54.21-.26S250.19,106.79,250.19,106.94Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "195.985px 106.94px"
    },
    id: "elh53w0xytu1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,66H310.42a6.33,6.33,0,0,1,6.33,6.33V102a0,0,0,0,1,0,0H192.67a0,0,0,0,1,0,0V72.29A6.33,6.33,0,0,1,199,66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "254.71px 84px"
    },
    id: "el8s5m2zvma3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.5 52.43 238.92 52.43 242.61 79.5 266.4 79.5 270.5 52.43",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "254.71px 65.965px"
    },
    id: "el7a9pnowmgkn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.78,66c0,.14-24.21.26-54.07.26s-54.07-.12-54.07-.26,24.21-.26,54.07-.26S308.78,65.82,308.78,66Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "254.71px 66px"
    },
    id: "el33grcqt7rd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.45,96.15c-.14,0-.26-5.09-.26-11.37s.12-11.37.26-11.37.26,5.09.26,11.37S195.59,96.15,195.45,96.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "195.45px 84.78px"
    },
    id: "elwmbi35y3mer",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.73,93.46c-.14,0-.26-4.63-.26-10.33s.12-10.32.26-10.32A100.39,100.39,0,0,1,313,83.13,100.67,100.67,0,0,1,312.73,93.46Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "312.751px 83.135px"
    },
    id: "elnni8qp948ok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.75,98.24c0,.15-24.85.26-55.5.26s-55.5-.11-55.5-.26,24.84-.26,55.5-.26S306.75,98.1,306.75,98.24Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "251.25px 98.24px"
    },
    id: "elh1jkodoy0p5",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2",
    className: "animable",
    style: {
      transformOrigin: "114.175px 315.04px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.67,457.82l-97-.06a21.13,21.13,0,0,1-21.13-21.13l0-243.24a21.14,21.14,0,0,1,21.15-21.13l97,.06a21.14,21.14,0,0,1,21.12,21.14l-.05,243.23A21.13,21.13,0,0,1,162.67,457.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "114.175px 315.04px"
    },
    id: "eljjuwx55q4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.64,180.92H143.83a4.67,4.67,0,0,0-4.57,4.77v3.42a4.68,4.68,0,0,1-4.57,4.77l-36.67,0a4.68,4.68,0,0,1-4.57-4.78v-3.41a4.68,4.68,0,0,0-4.57-4.78H65.81A14.79,14.79,0,0,0,51,195.66l0,237.42a14.8,14.8,0,0,0,14.79,14.8l96.83.06a14.8,14.8,0,0,0,14.81-14.8l.05-237.41A14.8,14.8,0,0,0,162.64,180.92Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "114.24px 314.425px"
    },
    id: "elagbg0o6tzz6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,279.15H177.43a0,0,0,0,1,0,0V435.21a12.73,12.73,0,0,1-12.73,12.73h-101A12.73,12.73,0,0,1,51,435.21V279.15A0,0,0,0,1,51,279.15Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "114.215px 363.545px"
    },
    id: "elw7qgg1r2odi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.95,
    y: 278.84,
    width: 95.53,
    height: 35.25,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "98.715px 296.465px"
    },
    id: "elr25g14ph0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.17,447.94a11.26,11.26,0,0,0,11.26-11.26V279.15h-31V447.94Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "161.93px 363.545px"
    },
    id: "el914sqhet3kl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.53,314.4c0,.15-28,.26-62.55.26s-62.55-.11-62.55-.26,28-.26,62.55-.26S174.53,314.26,174.53,314.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "111.98px 314.4px"
    },
    id: "elx02cb8civ",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.53,348.7c0,.14-28,.26-62.55.26s-62.55-.12-62.55-.26,28-.26,62.55-.26S174.53,348.55,174.53,348.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "111.98px 348.7px"
    },
    id: "elorbivzpdr6m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.53,385c0,.15-28,.26-62.55.26s-62.55-.11-62.55-.26,28-.26,62.55-.26S174.53,384.87,174.53,385Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "111.98px 385px"
    },
    id: "el07he0cs6zcb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.53,419.31c0,.14-28,.26-62.55.26s-62.55-.12-62.55-.26,28-.26,62.55-.26S174.53,419.17,174.53,419.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "111.98px 419.31px"
    },
    id: "el0s0c3009xld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9,419.31c-.15,0-.26-31.27-.26-69.83s.11-69.84.26-69.84.26,31.26.26,69.84S82,419.31,81.9,419.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "81.9px 349.475px"
    },
    id: "eluoolx653b2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.19,448c-.14,0-.26-37.69-.26-84.18s.12-84.18.26-84.18.26,37.68.26,84.18S114.33,448,114.19,448Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "114.19px 363.82px"
    },
    id: "el3tax954g03j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.48,447.94c-.14,0-.26-37.68-.26-84.15s.12-84.15.26-84.15.26,37.67.26,84.15S146.63,447.94,146.48,447.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "146.48px 363.79px"
    },
    id: "elfvgmnsp2zli",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.72,326.88V328L66,338.65H64.18l4.66-10.31H63.46v2.1H61.84v-3.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "66.28px 332.765px"
    },
    id: "elgtw4o7enytu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.11,335.32c0,2.14-1.81,3.46-4.69,3.46s-4.65-1.32-4.65-3.46a2.91,2.91,0,0,1,2.06-2.84,2.67,2.67,0,0,1-1.64-2.54c0-2,1.69-3.2,4.23-3.2s4.27,1.23,4.27,3.2a2.67,2.67,0,0,1-1.66,2.54A2.92,2.92,0,0,1,103.11,335.32Zm-1.68-.05c0-1.3-1.14-2.1-3-2.1s-3,.8-3,2.1,1.11,2.15,3,2.15S101.43,336.6,101.43,335.27ZM95.85,330c0,1.16,1,1.88,2.57,1.88s2.63-.72,2.63-1.88-1-1.9-2.63-1.9S95.85,328.83,95.85,330Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.4399px 332.76px"
    },
    id: "el9mmvc7jzsrs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.93,332.61c0,4-2.27,6.17-5.56,6.17a5.7,5.7,0,0,1-2.93-.68l.64-1.32a4.08,4.08,0,0,0,2.27.56c2.39,0,3.9-1.5,3.9-4.44v-.42a3.94,3.94,0,0,1-3.39,1.55c-2.34,0-4-1.4-4-3.57s1.81-3.72,4.15-3.72C133.15,326.74,134.93,328.86,134.93,332.61Zm-2.06-2.23c0-1.21-1-2.27-2.81-2.27a2.31,2.31,0,0,0-2.59,2.28c0,1.38,1,2.27,2.67,2.27A2.45,2.45,0,0,0,132.87,330.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.395px 332.762px"
    },
    id: "elaohdwiy04k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.21,294.7a2.51,2.51,0,1,1,2.5,2.78A2.5,2.5,0,0,1,125.21,294.7Zm3.55,0c0-1.08-.42-1.59-1-1.59s-1,.53-1,1.59.43,1.6,1,1.6S128.76,295.78,128.76,294.7ZM133.7,292h1.71l-6.87,10.06h-1.71Zm-1.65,7.4a2.51,2.51,0,1,1,2.49,2.78A2.5,2.5,0,0,1,132.05,299.44Zm3.54,0c0-1.06-.42-1.59-1.05-1.59s-1,.52-1,1.59.43,1.6,1,1.6S135.59,300.51,135.59,299.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "131.125px 297.09px"
    },
    id: "elx9vhy11fxa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23,297.05a5.12,5.12,0,0,1,5.36-5.18,5,5,0,0,1,3.84,1.58l-.94.91a3.72,3.72,0,0,0-2.84-1.2,3.89,3.89,0,1,0,0,7.77,3.76,3.76,0,0,0,2.84-1.21l.94.91a5,5,0,0,1-3.86,1.59A5.11,5.11,0,0,1,62.23,297.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "66.8298px 297.045px"
    },
    id: "el59o359nwwp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.39,371.23H70.15v2.9H68.52v-2.9H62v-1.17l6-7.71h1.82l-5.77,7.44h4.52v-2.56h1.58v2.56h2.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "67.195px 368.24px"
    },
    id: "elgpcydgtuzeq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.09,370.59c0,2-1.45,3.67-4.46,3.67a6.76,6.76,0,0,1-4.32-1.43l.78-1.33a5.28,5.28,0,0,0,3.53,1.26c1.78,0,2.79-.82,2.79-2.1s-.84-2.15-3.57-2.15H94.17l.62-6.16h6.64v1.47H96.2l-.32,3.23H97.2C100.71,367.05,102.09,368.51,102.09,370.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "97.7px 368.306px"
    },
    id: "elyvf7m56ekxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.29,370.54c0,2.27-1.84,3.72-4.17,3.72-3.16,0-5-2.12-5-5.87,0-4,2.27-6.17,5.57-6.17a5.7,5.7,0,0,1,2.93.69l-.64,1.31a4.15,4.15,0,0,0-2.26-.55c-2.38,0-3.91,1.49-3.91,4.44,0,.13,0,.26,0,.42a3.92,3.92,0,0,1,3.38-1.55C133.59,367,135.29,368.37,135.29,370.54Zm-1.63.07c0-1.38-1-2.27-2.69-2.27a2.44,2.44,0,0,0-2.71,2.29c0,1.21,1,2.27,2.79,2.27A2.33,2.33,0,0,0,133.66,370.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.705px 368.238px"
    },
    id: "elhyl1xhmgdr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8,397.15v11.77H64.13V398.61H61.47v-1.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "63.635px 403.035px"
    },
    id: "elf4udzhety49",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.11,407.46v1.46H93.65v-1.15l4.79-4.62c1.24-1.21,1.48-1.95,1.48-2.69,0-1.21-.86-1.95-2.51-1.95a3.69,3.69,0,0,0-3,1.28l-1.14-1A5.43,5.43,0,0,1,97.57,397c2.45,0,4,1.26,4,3.28,0,1.15-.34,2.17-1.93,3.7l-3.6,3.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "97.69px 402.957px"
    },
    id: "els63rp2txpi9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.23,405.45c0,2-1.46,3.6-4.46,3.6a6.68,6.68,0,0,1-4.32-1.43l.77-1.32a5.32,5.32,0,0,0,3.55,1.26c1.77,0,2.78-.81,2.78-2.09s-.89-2.05-2.91-2.05h-.94v-1.18l3-3.63H126v-1.46h7.77v1.14l-3.08,3.8C133,402.31,134.23,403.64,134.23,405.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "129.84px 403.101px"
    },
    id: "elu90bxdbbo4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.17,433.57c0-3.83,2-6,4.81-6s4.79,2.19,4.79,6-2,6-4.79,6S76.17,437.4,76.17,433.57Zm7.92,0c0-3-1.28-4.52-3.11-4.52s-3.13,1.51-3.13,4.52,1.28,4.52,3.13,4.52S84.09,436.58,84.09,433.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "80.97px 433.57px"
    },
    id: "elzp9yi351z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.67,434.09a3.3,3.3,0,0,1-.28,1.21l-.79,2.34h-1.06l.62-2.5a1.09,1.09,0,0,1-.71-1.05,1.1,1.1,0,0,1,1.13-1.14A1.08,1.08,0,0,1,131.67,434.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.56px 435.295px"
    },
    id: "elhtcny4ncrh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.65,
    y: 430.62,
    width: 11.48,
    height: 1.21,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.39px 431.225px"
    },
    id: "elpqhdwnuwojo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.65,
    y: 434.26,
    width: 11.48,
    height: 1.21,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.39px 434.865px"
    },
    id: "elb25d3a61isi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.1,
    y: 401.95,
    width: 8.6,
    height: 0.9,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.4px 402.4px"
    },
    id: "elr7vtyv5nklm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14,403.29h-9.49V401.5h9.49Zm-8.6-.88,7.71,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.395px 402.395px"
    },
    id: "elwkg8ab9yauh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elh8f85u8af88"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.1,
    y: 401.95,
    width: 8.6,
    height: 0.9,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.4px 402.4px",
      transform: "rotate(-90deg)"
    },
    className: "animable",
    id: "elj4uc63aef2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.29,407.14H161.5v-9.48h1.79Zm-.91-.89h0l0-7.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.395px 402.4px"
    },
    id: "el7b4h5i9v9jy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.38 329.4 165.12 328.13 162.4 330.85 159.68 328.13 158.41 329.4 161.13 332.12 158.41 334.84 159.68 336.1 162.39 333.38 165.11 336.1 166.38 334.83 163.66 332.12 166.38 329.4",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.395px 332.115px"
    },
    id: "elqp2jtd3uhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.1,
    y: 367.91,
    width: 8.6,
    height: 0.9,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.4px 368.36px"
    },
    id: "el1x17esnbbt8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14,369.25h-9.49v-1.79h9.49Zm-8.6-.88,7.71,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.395px 368.355px"
    },
    id: "el6493vdyoqzw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.1,
    y: 297.19,
    width: 8.6,
    height: 0.9,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.4px 297.64px"
    },
    id: "elrjgumx6zsso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14,298.53h-9.49v-1.79h9.49Zm-8.6-.88,7.71,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.395px 297.635px"
    },
    id: "el9cmueg0aai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.39,
    cy: 292.91,
    r: 1.44,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.39px 292.91px"
    },
    id: "elz0y4223ri5m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.84,302.1a1.45,1.45,0,1,1-1.45-1.44A1.45,1.45,0,0,1,163.84,302.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.39px 302.11px"
    },
    id: "el487alw7x5lp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.5 295.13 101.73 294.36 100.08 296.01 98.43 294.36 97.67 295.13 99.31 296.78 97.67 298.43 98.43 299.19 100.08 297.54 101.73 299.19 102.5 298.43 100.85 296.78 102.5 295.13",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "100.085px 296.775px"
    },
    id: "elp8jaaqsemn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,301.43H96.26a1.48,1.48,0,0,1-1.08-.47l-2.9-3.15a1.53,1.53,0,0,1,0-2.06l2.9-3.15a1.49,1.49,0,0,1,1.08-.48h8.24a1.49,1.49,0,0,1,1.47,1.51v6.3A1.49,1.49,0,0,1,104.5,301.43Zm-8.24-8.31a.49.49,0,0,0-.34.15L93,296.42a.53.53,0,0,0,0,.71l2.9,3.15a.45.45,0,0,0,.34.15h8.24a.48.48,0,0,0,.47-.5v-6.3a.49.49,0,0,0-.47-.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.9258px 296.775px"
    },
    id: "elqq3vr75megr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,242.84v20.92h-1.52V244.21h-5.11v-1.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.085px 253.3px"
    },
    id: "elecg2dz337cc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.07,242.84v1.07l-9,19.85H118.4l8.91-19.55H115.56v4h-1.5v-5.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "121.565px 253.295px"
    },
    id: "elhl5zg236e18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,257.87c0,3.47-2.51,6-7.33,6-3.07,0-5.91-1.14-7.38-2.81l.78-1.17a8.9,8.9,0,0,0,6.6,2.58c3.77,0,5.77-1.8,5.77-4.64s-1.91-4.63-6.09-4.63h-1.32v-1.11l6.19-7.92H131.31v-1.37h13.12v1.07l-6.28,8C142.91,252.07,145.24,254.46,145.24,257.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.885px 253.335px"
    },
    id: "elsnwqj8hfnbf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.19,258c0,3.65-3,5.89-7.95,5.89s-7.9-2.24-7.9-5.89c0-2.63,1.62-4.45,4.46-5.2-2.39-.78-3.71-2.42-3.71-4.72,0-3.35,2.81-5.41,7.15-5.41s7.2,2.06,7.2,5.41c0,2.3-1.35,3.94-3.77,4.72C162.54,253.57,164.19,255.42,164.19,258Zm-1.53,0c0-2.78-2.39-4.54-6.42-4.54s-6.37,1.76-6.37,4.54,2.33,4.58,6.37,4.58S162.66,260.83,162.66,258Zm-6.42-5.8c3.55,0,5.67-1.58,5.67-4.06S159.7,244,156.24,244s-5.62,1.59-5.62,4.13S152.68,252.22,156.24,252.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "156.265px 253.28px"
    },
    id: "eltktt61ple4a",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2",
    className: "animable",
    style: {
      transformOrigin: "253.625px 398.055px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "304.61 341.35 304.61 341.43 304.61 382.37 313.96 382.37 304.61 341.35",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "309.285px 361.86px"
    },
    id: "elwelnurvzbvs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.92,
    y: 341.35,
    width: 47.69,
    height: 42.53,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "280.765px 362.615px"
    },
    id: "el6qyod8ywoca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.08,
    y: 359.61,
    width: 6.52,
    height: 6.87,
    style: {
      fill: "#68A1D6",
      transformOrigin: "290.34px 363.045px"
    },
    id: "el7f3cey2v2g5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.21,380.37a2.56,2.56,0,0,1,0-.47c0-.35,0-.82,0-1.42,0-1.28,0-3.12-.05-5.45,0-4.79-.07-11.62-.11-19.92v-.21h.21l39.55,0c-.05-.05.5.5.26.27h0v14.17c0,4.56,0,8.94,0,13.08v.24h-.24l-28.61-.12-8.1-.06-2.13,0-.54,0h0l.57,0,2.18,0,8.15-.06,28.45-.12-.23.24c0-4.14,0-8.52,0-13.08,0-2.29,0-4.61,0-7v-7.19h0c-.23-.24.32.31.26.25l-39.55-.05.21-.21c-.05,8.25-.09,15-.11,19.79,0,2.35,0,4.2-.06,5.5,0,.62,0,1.1,0,1.46S261.21,380.36,261.21,380.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "281.09px 366.778px"
    },
    id: "el5b5f24wkyu7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.92,
    y: 341.35,
    width: 47.69,
    height: 8.2,
    style: {
      fill: "#68A1D6",
      transformOrigin: "280.765px 345.45px"
    },
    id: "elh2er6jpmsw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.92,383.88s0-.25,0-.75,0-1.28,0-2.25c0-2,0-4.91-.06-8.6,0-7.47-.06-18.12-.11-30.93v-.22h.22l47.69,0c-.05-.06.5.49.26.26h0v11.4c0,3.73,0,7.4,0,11,0,7.13,0,13.9,0,20.15v.23h-.23L270,384l-9.69-.06-2.55,0-.64,0c-.14,0-.22,0-.21,0h.23l.68,0,2.58,0,9.75-.06,34.45-.12-.23.23c0-6.25,0-13,0-20.15,0-3.57,0-7.24,0-11v-11.4h0l.26.26-47.69,0,.22-.22c-.05,12.75-.09,23.35-.11,30.79,0,3.71,0,6.63-.06,8.65,0,1,0,1.75,0,2.29S256.92,383.88,256.92,383.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.865px 362.648px"
    },
    id: "elwe33ui7p4lp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.65,359.61c0,.14-8.8.26-19.66.26s-19.65-.12-19.65-.26,8.79-.26,19.65-.26S300.65,359.46,300.65,359.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.995px 359.61px"
    },
    id: "el0cksphudms1t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.65,366.47c0,.15-8.8.27-19.66.27s-19.65-.12-19.65-.27,8.79-.26,19.65-.26S300.65,366.33,300.65,366.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.995px 366.475px"
    },
    id: "elqggvip6ph8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.65,373.34c0,.15-8.8.26-19.66.26s-19.65-.11-19.65-.26,8.79-.26,19.65-.26S300.65,373.2,300.65,373.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.995px 373.34px"
    },
    id: "elny6ui4nv2yj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.64,380.3c-.14,0-.26-6.07-.26-13.56s.12-13.56.26-13.56.26,6.07.26,13.56S267.79,380.3,267.64,380.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "267.64px 366.74px"
    },
    id: "elfywju23hee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.1,380.3c-.14,0-.26-6.07-.26-13.56s.12-13.56.26-13.56.26,6.07.26,13.56S274.24,380.3,274.1,380.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "274.1px 366.74px"
    },
    id: "elxxsar3gquji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.62,380.3c-.14,0-.26-6.07-.26-13.56s.12-13.56.26-13.56.26,6.07.26,13.56S280.77,380.3,280.62,380.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.62px 366.74px"
    },
    id: "el7wleqt2eboa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.08,380.3c-.15,0-.26-6.07-.26-13.56s.11-13.56.26-13.56.26,6.07.26,13.56S287.22,380.3,287.08,380.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "287.08px 366.74px"
    },
    id: "ell9lfd69e3um",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6,380.3c-.15,0-.26-6.07-.26-13.56s.11-13.56.26-13.56.26,6.07.26,13.56S293.74,380.3,293.6,380.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "293.6px 366.74px"
    },
    id: "eloz99ozmj38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.53,
    y: 353.76,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "298.295px 354.565px"
    },
    id: "elfpqglwbrsm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.58,
    y: 360.72,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "298.345px 361.525px"
    },
    id: "elljuvqyovht9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.58,
    y: 367.67,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "298.345px 368.475px"
    },
    id: "el7eil4jg8zs5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.66,
    y: 374.62,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "298.425px 375.425px"
    },
    id: "elqsmhfmuq28q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.67,
    y: 353.76,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "284.435px 354.565px"
    },
    id: "elp7sg6ratppl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.73,
    y: 360.72,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "284.495px 361.525px"
    },
    id: "elmxlry2wt05",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.73,
    y: 367.67,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "284.495px 368.475px"
    },
    id: "el2kj295yds9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.8,
    y: 374.62,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "284.565px 375.425px"
    },
    id: "eluq8dan6fz7h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.75,
    y: 353.76,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "271.515px 354.565px"
    },
    id: "elspufls3aic",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.8,
    y: 360.72,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "271.565px 361.525px"
    },
    id: "elq200n0pvpt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.8,
    y: 367.67,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "271.565px 368.475px"
    },
    id: "el5j6mf0he21d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.88,
    y: 374.62,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "271.645px 375.425px"
    },
    id: "eleylmh8mpfw5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.5,
    y: 353.76,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "278.265px 354.565px"
    },
    id: "elkilxf2cfhvj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.55,
    y: 360.72,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "278.315px 361.525px"
    },
    id: "els4jnph1b9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.55,
    y: 367.67,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "278.315px 368.475px"
    },
    id: "elohb68a6zj8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.63,
    y: 374.62,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "278.395px 375.425px"
    },
    id: "elpqv1l17z76d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.42,
    y: 353.76,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "265.185px 354.565px"
    },
    id: "el46td1zkmn2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.47,
    y: 360.72,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "265.235px 361.525px"
    },
    id: "elp1g83fpi7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.47,
    y: 367.67,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "265.235px 368.475px"
    },
    id: "elwomek3k1wa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.55,
    y: 374.62,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "265.315px 375.425px"
    },
    id: "el935hfftdd2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.08,
    y: 353.76,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "290.845px 354.565px"
    },
    id: "el5ue31andp58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.14,
    y: 367.67,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "290.905px 368.475px"
    },
    id: "elib6a48lvj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.14,
    y: 374.62,
    width: 3.53,
    height: 1.61,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "290.905px 375.425px"
    },
    id: "eluer1ios8e4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.73,359.16a33.54,33.54,0,0,1,3.42-3.6,37.07,37.07,0,0,1,3.56-3.45,18.06,18.06,0,0,1-3.19,3.82A18.73,18.73,0,0,1,286.73,359.16Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "290.22px 355.635px"
    },
    id: "eljxhqy55jv1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.19,359.8a36,36,0,0,1-4.7-3.84,35.58,35.58,0,0,1-4.34-4.22,36.21,36.21,0,0,1,4.69,3.83A35.73,35.73,0,0,1,295.19,359.8Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "290.67px 355.77px"
    },
    id: "eld5w9wx0v2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.85,345.06h0a.87.87,0,0,1-.88-.88V339a.88.88,0,0,1,.88-.89h0a.88.88,0,0,1,.88.89v5.16A.87.87,0,0,1,262.85,345.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "262.85px 341.585px"
    },
    id: "elcflyl9mjsa5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.6,345.06h0a.88.88,0,0,1-.88-.88V339a.89.89,0,0,1,.88-.89h0a.89.89,0,0,1,.89.89v5.16A.88.88,0,0,1,268.6,345.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "268.605px 341.585px"
    },
    id: "elc3mlj2iqcbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.38,345.06h0a.87.87,0,0,1-.88-.88V339a.88.88,0,0,1,.88-.89h0a.89.89,0,0,1,.88.89v5.16A.88.88,0,0,1,274.38,345.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "274.38px 341.585px"
    },
    id: "elcddbsjja7au",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.15,345.06h0a.87.87,0,0,1-.88-.88V339a.88.88,0,0,1,.88-.89h0a.88.88,0,0,1,.88.89v5.16A.87.87,0,0,1,280.15,345.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.15px 341.585px"
    },
    id: "elxmgzrncvlb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.92,345.06h0a.88.88,0,0,1-.88-.88V339a.89.89,0,0,1,.88-.89h0a.89.89,0,0,1,.89.89v5.16A.88.88,0,0,1,285.92,345.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "285.925px 341.585px"
    },
    id: "elz9ntyap8iog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,345.06h0a.87.87,0,0,1-.88-.88V339a.88.88,0,0,1,.88-.89h0a.88.88,0,0,1,.88.89v5.16A.87.87,0,0,1,291.7,345.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "291.7px 341.585px"
    },
    id: "eltnw14bzs1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.47,345.06h0a.87.87,0,0,1-.88-.88V339a.88.88,0,0,1,.88-.89h0a.88.88,0,0,1,.88.89v5.16A.87.87,0,0,1,297.47,345.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "297.47px 341.585px"
    },
    id: "eluehv1km2hq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.64,
    y: 382.37,
    width: 131.97,
    height: 10.73,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "253.625px 387.735px"
    },
    id: "el5nd9ao843a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.42,
    y: 390.52,
    width: 120.47,
    height: 31.38,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "252.655px 406.21px"
    },
    id: "el4fibjnhaure",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.42,
    y: 389.56,
    width: 10.43,
    height: 68.44,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.635px 423.78px"
    },
    id: "eltf43x0wru9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.46,
    y: 389.56,
    width: 10.43,
    height: 68.44,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "307.675px 423.78px"
    },
    id: "elx84emsv0s4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.77,393.1c0,.14-29.62.26-66.14.26s-66.15-.12-66.15-.26,29.61-.26,66.15-.26S319.77,393,319.77,393.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "253.625px 393.1px"
    },
    id: "elzsa79tj111f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,393.43c.15,0,.23,14.46.19,32.28S203,458,202.86,458s-.23-14.45-.19-32.28S202.86,393.43,203,393.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "202.93px 425.715px"
    },
    id: "eleh9kfuj90ye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.87,393.43c.15,0,.26,13.54.26,30.24s-.11,30.23-.26,30.23-.26-13.53-.26-30.23S302.73,393.43,302.87,393.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "302.87px 423.665px"
    },
    id: "elelw03tw9mn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.85,418.33s0-.13,0-.38,0-.63,0-1.11c0-1,0-2.41,0-4.26,0-3.73,0-9.14-.08-16l.15.15-92.34.11h0l.26-.26v21.74l-.26-.25,65.83.11,19.43.08,5.25,0,1.37,0h.47l-.44,0-1.33,0-5.2,0-19.37.07-66,.12h-.25v-.26c0-7,0-14.29,0-21.74v-.26h.27l92.34.11H299v.15c0,6.89-.06,12.33-.08,16.08,0,1.83,0,3.25,0,4.23,0,.46,0,.82,0,1.08S298.85,418.33,298.85,418.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.67px 407.32px"
    },
    id: "eljsj41cctyel",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.36,408c-.05,0-.06-.25-.19-.67a2.88,2.88,0,0,0-1-1.45,2.68,2.68,0,0,0-2.51-.33,2.62,2.62,0,0,0,0,4.91,2.7,2.7,0,0,0,2.51-.34,2.82,2.82,0,0,0,1-1.44c.13-.42.14-.68.19-.68a1.36,1.36,0,0,1,0,.72,2.78,2.78,0,0,1-1,1.7,3,3,0,0,1-2.89.49,3.08,3.08,0,0,1,0-5.81,3,3,0,0,1,2.89.49,2.79,2.79,0,0,1,1,1.69A1.33,1.33,0,0,1,254.36,408Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "251.412px 408.005px"
    },
    id: "elc8n3ug7qp1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.41 364.54 275.85 374.58 255.22 374.58 265.41 364.54",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "265.535px 369.56px"
    },
    id: "eljeprsoi205",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.22 374.58 265.41 364.54 245.24 364.54 255.22 374.58",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "255.325px 369.56px"
    },
    id: "eln3h4339kd8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.5 374.58 215.39 362.35 244.08 362.35 235.25 374.58 206.5 374.58",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "225.29px 368.465px"
    },
    id: "el543mwwa8mtx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.08 362.35 255.22 374.58 235.25 374.58 244.08 362.35",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "245.235px 368.465px"
    },
    id: "elrqdyfbtbiba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.85,374.58a5.17,5.17,0,0,1-.8-.67l-2.15-2-7.64-7.22h.31l-10.16,10.07-.2.19-.18-.2-1-1.06-10.15-11.2.35,0-6.49,8.81-1.84,2.45a5.86,5.86,0,0,1-.69.84,6.51,6.51,0,0,1,.58-.92l1.74-2.52,6.33-8.93.16-.22.19.2,10.21,11.16.95,1.06H255l10.22-10,.15-.15.16.15,7.51,7.36,2.07,2.07A6.89,6.89,0,0,1,275.85,374.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "255.53px 368.475px"
    },
    id: "els644sj8isw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5,374.58a7.41,7.41,0,0,1,.59-1l1.79-2.6,6.28-8.89.08-.11H222c6,0,11.49,0,15.44.08l4.68.08a11.73,11.73,0,0,1,1.71.1,10.16,10.16,0,0,1-1.71.1l-4.68.09c-3.95,0-9.41.07-15.44.07h-6.66l.2-.1-6.44,8.78c-.78,1-1.41,1.86-1.9,2.51A5.85,5.85,0,0,1,206.5,374.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.165px 368.28px"
    },
    id: "eljrihc9p09r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.18,364.54a86.07,86.07,0,0,1-9.55.26,85.92,85.92,0,0,1-9.55-.26,89,89,0,0,1,9.55-.26A89.1,89.1,0,0,1,265.18,364.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "255.63px 364.542px"
    },
    id: "eldl659h5sdm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,370.81a79.49,79.49,0,0,1-9.18.26,79.74,79.74,0,0,1-9.19-.26,82.55,82.55,0,0,1,9.19-.26A82.29,82.29,0,0,1,232,370.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "222.815px 370.812px"
    },
    id: "elyd1q1p1m1ac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.44,368.34a79.74,79.74,0,0,1-9.19.26,79.74,79.74,0,0,1-9.19-.26,82.55,82.55,0,0,1,9.19-.26A82.55,82.55,0,0,1,234.44,368.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.25px 368.342px"
    },
    id: "el7btlynggvsm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.91,365.87a79.74,79.74,0,0,1-9.19.26,79.74,79.74,0,0,1-9.19-.26,82.55,82.55,0,0,1,9.19-.26A82.55,82.55,0,0,1,236.91,365.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "227.72px 365.872px"
    },
    id: "elqtdim695dgq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.82,
    y: 374.58,
    width: 71.38,
    height: 7.79,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "236.51px 378.475px"
    },
    id: "el04ixbn4i9ncu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.42,
    y: 374.58,
    width: 47.79,
    height: 7.79,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "248.315px 378.475px"
    },
    id: "el5k9cug5n3y6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,382.37a2.66,2.66,0,0,1,0-.52c0-.39,0-.89,0-1.52,0-1.39,0-3.32-.07-5.75v-.15h.15c7.1-.07,18.66-.11,31.7-.11l27.93.08,8.47.08,2.3,0a5.06,5.06,0,0,1,.8.05,3.87,3.87,0,0,1-.8.05l-2.3.05-8.47.09-27.93.07c-13,0-24.6,0-31.7-.1l.16-.16c0,2.43-.06,4.36-.07,5.75,0,.63,0,1.13,0,1.52A1.93,1.93,0,0,1,200.82,382.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "236.425px 378.345px"
    },
    id: "el36t297qtocd",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "360.435px 334.42px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.94,
    y: 398.95,
    width: 9.17,
    height: 59.7,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "367.525px 428.8px"
    },
    id: "elbbeme5m4s5u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.13,
    y: 398.95,
    width: 9.17,
    height: 59.02,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "420.715px 428.46px"
    },
    id: "elzww57bjx19",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.15,
    y: 420.16,
    width: 48.61,
    height: 8.13,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "393.455px 424.225px"
    },
    id: "el43xedapavwl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.3,399s0,.1,0,.3v.88c0,.79,0,1.93,0,3.39,0,3,0,7.23.06,12.51,0,10.61,0,25.31.06,41.75V458h-9.55v-.19c.06-16.33.12-30.91.16-41.42,0-5.24.07-9.47.09-12.4,0-1.45,0-2.57.05-3.36l0-.87a.94.94,0,0,1,0-.29s0,.1,0,.29,0,.5,0,.87c0,.79,0,1.91,0,3.36,0,2.93,0,7.16,0,12.4,0,10.51,0,25.09,0,41.42l-.19-.19h9.17l-.2.19c0-16.44,0-31.14.06-41.75,0-5.28,0-9.55.06-12.51,0-1.46,0-2.6,0-3.39l0-.88A1,1,0,0,1,425.3,399Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "420.645px 428.5px"
    },
    id: "elfa27yag2nj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,401.48a1.64,1.64,0,0,1,0,.29c0,.21,0,.49,0,.85,0,.77,0,1.87,0,3.28,0,2.87,0,7,0,12.13,0,10.3,0,24.58,0,40.62l-.19-.2h9.17l-.2.2c0-16.56,0-31.39.06-42.11,0-5.33,0-9.64.06-12.64,0-1.47,0-2.62,0-3.42,0-.38,0-.67,0-.89a1,1,0,0,1,0-.3s0,.1,0,.3,0,.51,0,.89c0,.8,0,1.95,0,3.42,0,3,0,7.31.06,12.64,0,10.72,0,25.55.06,42.11v.19h-9.55v-.19c.05-16,.1-30.32.13-40.62,0-5.13.06-9.26.08-12.13,0-1.41,0-2.51,0-3.28,0-.36,0-.64,0-.85A1.64,1.64,0,0,1,363,401.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "367.245px 429.065px"
    },
    id: "elc0psqqxkks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 371.37,
    width: 89.26,
    height: 28.2,
    rx: 9.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "394.76px 385.47px"
    },
    id: "elf0in5l6r1x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,399.57c0-.11,14.82-.19,33.08-.19s33.09.08,33.09.19-14.81.19-33.09.19S366.25,399.68,366.25,399.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "399.335px 399.57px"
    },
    id: "eljfh6zkndprd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc9hqhhuh11g"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "397.622px 386.296px"
    },
    className: "animable",
    id: "elf2q3ef5ch46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.37,369.53l-37.11-1.25c-2.18-.08-4.57-.08-6.26,1.3s-2.09,3.47-2.5,5.48l-5.64,27.28,1.18,2a35.23,35.23,0,0,0,15.23-20.05c.63-2.22,1.34-4.85,3.5-5.65a6.63,6.63,0,0,1,3-.15l8.77.88c4.2.42,8.57.83,12.56-.56S423.63,373.75,423.37,369.53Z",
    id: "elps55ryd6m9b",
    className: "animable",
    style: {
      transformOrigin: "397.622px 386.296px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M399.3,190.67a5.17,5.17,0,0,1,4.34-1.44,2.91,2.91,0,0,0,1.89,0,4.23,4.23,0,0,0,.92-1,2.6,2.6,0,0,1,3.75,0,3.17,3.17,0,0,0,.72.74c1.23.68,2.66-1.62,3.88-.92a3,3,0,0,0-1.41,1,1.33,1.33,0,0,0,.11,1.65c1.14,1.05,3.11-1.19,4.38-.31.69.47.76,1.67,1.57,1.88a2.85,2.85,0,0,0,1,0,2.15,2.15,0,0,1,2.23,1.9c.07.92-.42,2,.25,2.67a2,2,0,0,0,1.64.28,5.62,5.62,0,0,1-.66,2.43,3.37,3.37,0,0,1,1,4.54,7.27,7.27,0,0,1,1.88,2,2.51,2.51,0,0,1,0,2.64,2.08,2.08,0,0,0-.37.51,1.3,1.3,0,0,0,0,.68,11.12,11.12,0,0,1,.47,2.59c-.05.88-.73,1.84-1.6,1.74-.21,0-.43-.1-.61,0a.57.57,0,0,0-.22.39,6.07,6.07,0,0,0,.08,1.9,2.49,2.49,0,0,1-.33,1.82,1.07,1.07,0,0,1-1.63.16c.22,1,.45,2,.68,3,.13.59.24,1.3-.2,1.71s-1.56.08-2-.59-.5-1.51-.92-2.18a4.64,4.64,0,0,1-.52-.81c-.09-.24-.11-.53-.3-.69-.39-.34-1,.2-1,.71a2.68,2.68,0,0,0,.75,1.31,1.29,1.29,0,0,1,.28,1.41c-.13.21-.36.35-.48.56-.44.74.64,1.49.75,2.34a2.07,2.07,0,0,1-.85,1.62c-.56.53-1.63.94-2,.24-.11-.24-.06-.53-.15-.78a1.78,1.78,0,0,0-.59-.72,4.15,4.15,0,0,1-1.14-2c.63.81,1.29,1.89.81,2.81a4.12,4.12,0,0,1-.88.94c-.6.6-1,1.39-1.58,2a2,2,0,0,1-2.29.57,1.91,1.91,0,0,1-3.24,1.82,1.79,1.79,0,0,0-.51-.48,1.37,1.37,0,0,0-.75,0,4.15,4.15,0,0,1-4-1.7l.76-.25A9.61,9.61,0,0,1,399,228a3.28,3.28,0,0,1-1.3-3.92c.29-.58.84-1.17.61-1.78-.15-.42-.62-.62-1-.78l-5.26-2a5,5,0,0,1-2.3-1.4,1.71,1.71,0,0,1,.19-2.42,4.91,4.91,0,0,0-1.79-2c-.87-.55-1.89-.81-2.79-1.32a2.8,2.8,0,0,1-1.6-2.45c.09-1,1.52-1.78,2.21-1-.1-1.55-2.86-1.71-3.06-3.25-.16-1.25,1.45-1.86,2.3-2.8-.16-.44-.59-.73-.76-1.16-.36-.91.59-1.78,1.48-2.18s2-.8,2.22-1.74-.57-2.09,0-2.93a1.11,1.11,0,0,1,1.46-.33c.75-1.76,4.07-.34,5.09-2a.75.75,0,0,0,.13-.43,1,1,0,0,0-.16-.36,8,8,0,0,0-1.46-1.17,1.5,1.5,0,0,1-.64-1.62c.24-.57,1.34-.53,1.31.1a1.38,1.38,0,0,1,2.09.57,1.48,1.48,0,0,1,1.86-.12,4.27,4.27,0,0,1,1.28,1.54",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "405.032px 209.918px"
    },
    id: "elnpi2n84tu7q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.08,191s-.18-.29-.6-.83a2.54,2.54,0,0,0-1-.77,1.36,1.36,0,0,0-1.53.24l-.1.12,0-.15a1.28,1.28,0,0,0-1.92-.52l-.21.17,0-.26c0-.31-.42-.45-.75-.33a.66.66,0,0,0-.34.9,2,2,0,0,0,.79,1,7.25,7.25,0,0,1,1.19.91.88.88,0,0,1,.3.82.94.94,0,0,1-.22.39,1.11,1.11,0,0,1-.3.31,3.08,3.08,0,0,1-1.63.54c-.57.06-1.15.06-1.71.16a1.6,1.6,0,0,0-1.33.84l-.08.19-.18-.11a.94.94,0,0,0-1,.08,1.15,1.15,0,0,0-.3,1.1c.06.43.22.89.25,1.41a1.81,1.81,0,0,1-.61,1.46c-.81.74-1.91.87-2.62,1.54a1.37,1.37,0,0,0-.56,1.18c0,.43.56.71.82,1.33l.05.13-.09.1a18.33,18.33,0,0,1-1.57,1.32,1.37,1.37,0,0,0-.59,1.56c.22.55.88.89,1.49,1.25a6,6,0,0,1,.93.65,1.7,1.7,0,0,1,.58,1.11l0,.73-.46-.55c-.48-.57-1.63,0-1.76.77a2.31,2.31,0,0,0,1.24,2.16c.78.52,1.77.78,2.7,1.28a5.22,5.22,0,0,1,2.22,2.33l.1.22-.2.12a1.47,1.47,0,0,0-.12,2,4.92,4.92,0,0,0,2.23,1.32l5.38,2a2.29,2.29,0,0,1,.72.41,1.14,1.14,0,0,1,.39.86,3.15,3.15,0,0,1-.62,1.48,2.55,2.55,0,0,0,.13,2.58,4.17,4.17,0,0,0,2.19,1.75,13.85,13.85,0,0,0,2.94.67l1.23.19-1.18.39-.77.25.15-.45a3.88,3.88,0,0,0,2,1.43A3.82,3.82,0,0,0,406,231a5.63,5.63,0,0,0,.66-.08,1.13,1.13,0,0,1,.88.17c.25.2.37.41.51.52a1.57,1.57,0,0,0,.49.31,1.68,1.68,0,0,0,1.17,0,1.63,1.63,0,0,0,1-1.94l-.22-.75.66.4a1.39,1.39,0,0,0,1.36-.09,3.6,3.6,0,0,0,1.15-1.15,8.73,8.73,0,0,1,1.18-1.45c.49-.4.81-.77.77-1.29a3.66,3.66,0,0,0-.91-1.89l.54-.25a3.7,3.7,0,0,0,.71,1.48,5.71,5.71,0,0,0,.6.61,2,2,0,0,1,.33.41,1.34,1.34,0,0,1,.15.54c0,.33.07.47.19.55a.82.82,0,0,0,.61,0,2.7,2.7,0,0,0,1.21-1,1.09,1.09,0,0,0,.12-1.32c-.12-.23-.29-.47-.44-.74a1.44,1.44,0,0,1-.21-1.05c.11-.43.48-.64.57-.78a.6.6,0,0,0,.06-.56c-.12-.46-.57-.8-.9-1.38a1.31,1.31,0,0,1-.15-1.06,1.09,1.09,0,0,1,.88-.72.75.75,0,0,1,.62.28,1.42,1.42,0,0,1,.23.49,1.52,1.52,0,0,0,.33.66c.79,1,.74,2.31,1.48,2.88.36.3.88.42,1.15.18s.29-.76.19-1.26c-.24-1.07-.48-2.12-.72-3.17l-.32-1.39.83,1.16a.67.67,0,0,0,.8.12,1,1,0,0,0,.6-.74,7.32,7.32,0,0,0-.08-2.36,3.05,3.05,0,0,1,0-.67.91.91,0,0,1,.42-.72,1.47,1.47,0,0,1,.75,0,.75.75,0,0,0,.44-.08,1.76,1.76,0,0,0,.83-1.75c0-.73-.34-1.46-.47-2.27a1.45,1.45,0,0,1,0-.71,1.94,1.94,0,0,1,.38-.55,1.75,1.75,0,0,0,.37-.91,2.79,2.79,0,0,0-.59-1.93,9.18,9.18,0,0,0-1.54-1.51l-.18-.15.13-.19a3.11,3.11,0,0,0-.93-4.19l-.2-.12.11-.21a5.23,5.23,0,0,0,.64-2.32l.27.25a2.8,2.8,0,0,1-1.5-.12,1.43,1.43,0,0,1-.76-1.34c0-1,.32-1.82-.16-2.49a1.9,1.9,0,0,0-2-.88,2,2,0,0,1-.7,0,1.2,1.2,0,0,1-.64-.39,7.31,7.31,0,0,1-.66-1.08,1.1,1.1,0,0,0-.77-.62,2.19,2.19,0,0,0-1.05.15,5.73,5.73,0,0,1-2.26.6,1.22,1.22,0,0,1-1-.73,1.53,1.53,0,0,1,0-1.19,2.78,2.78,0,0,1,1.63-1.4v.31c-.53-.3-1.17.09-1.71.41a2.7,2.7,0,0,1-1.88.61,1.46,1.46,0,0,1-.79-.59,3.08,3.08,0,0,0-.58-.61,2.52,2.52,0,0,0-1.49-.44,2.42,2.42,0,0,0-1.39.44,6.34,6.34,0,0,0-.94,1,1.52,1.52,0,0,1-1.28.45c-.43,0-.81-.14-1.17-.18a5.19,5.19,0,0,0-3.24.67,9.66,9.66,0,0,0-.95.69,3.48,3.48,0,0,1,.9-.77,5.18,5.18,0,0,1,3.31-.78c.38,0,.76.14,1.16.16a1.26,1.26,0,0,0,1.1-.4,6.7,6.7,0,0,1,1-1.09,2.71,2.71,0,0,1,1.53-.52,2.74,2.74,0,0,1,1.67.49c.53.34.75,1,1.28,1.13s1.09-.27,1.63-.6a4.67,4.67,0,0,1,.92-.47,1.29,1.29,0,0,1,1.13.05l.3.17-.32.14a2.47,2.47,0,0,0-1.43,1.21,1.3,1.3,0,0,0,0,.91.9.9,0,0,0,.7.5,5.81,5.81,0,0,0,2.08-.6,2.4,2.4,0,0,1,1.26-.17,1.54,1.54,0,0,1,1,.8,9.16,9.16,0,0,0,.61,1,.89.89,0,0,0,1,.21,2.37,2.37,0,0,1,2.44,1.08,2.29,2.29,0,0,1,.34,1.39c0,.47-.11.91-.1,1.33a1,1,0,0,0,.49.92,2.31,2.31,0,0,0,1.24.07l.29,0,0,.29a5.78,5.78,0,0,1-.68,2.54l-.09-.33a3.6,3.6,0,0,1,1.1,4.89l-.05-.34a9.12,9.12,0,0,1,1.63,1.6,3.28,3.28,0,0,1,.7,2.3,2.32,2.32,0,0,1-.49,1.19c-.29.33-.36.46-.3.83.12.73.42,1.47.49,2.32a2.31,2.31,0,0,1-1.14,2.29c-.42.27-1.14,0-1.18.1s-.1.13-.12.31a2.6,2.6,0,0,0,0,.56,7.54,7.54,0,0,1,.07,2.53,1.44,1.44,0,0,1-2.41.81l.51-.23c.24,1.05.48,2.1.73,3.17a3.32,3.32,0,0,1,.07.9,1.37,1.37,0,0,1-.45.92,1.2,1.2,0,0,1-1,.25,2,2,0,0,1-.88-.41,3.27,3.27,0,0,1-.91-1.56,4.35,4.35,0,0,0-.68-1.44,2.15,2.15,0,0,1-.42-.84c-.08-.28-.16-.35-.24-.34a.52.52,0,0,0-.36.33.75.75,0,0,0,.11.57c.22.43.75.82.95,1.5a1.2,1.2,0,0,1-.15,1.09c-.25.3-.45.41-.47.57-.1.33.31.83.6,1.37a1.73,1.73,0,0,1,.24,1,2,2,0,0,1-.4.95,3.39,3.39,0,0,1-1.5,1.18,1.31,1.31,0,0,1-1.11,0,1.17,1.17,0,0,1-.49-1,.81.81,0,0,0-.3-.58,5.2,5.2,0,0,1-.65-.67,4.24,4.24,0,0,1-.83-1.72l-.32-1.41.85,1.16a4.21,4.21,0,0,1,1,2.24,1.8,1.8,0,0,1-.29,1.05,3.86,3.86,0,0,1-.68.71,7.79,7.79,0,0,0-1.1,1.35,4.19,4.19,0,0,1-1.35,1.33,2,2,0,0,1-1.95.08l.44-.34a2.2,2.2,0,0,1-2.94,2.65,2.16,2.16,0,0,1-.69-.43c-.21-.19-.34-.4-.46-.48s-.65,0-1.16,0a4.47,4.47,0,0,1-1.45-.21,4.36,4.36,0,0,1-2.28-1.67l-.23-.32.38-.13.76-.24.05.57a14.41,14.41,0,0,1-3.07-.72,4.73,4.73,0,0,1-2.47-2,3.12,3.12,0,0,1-.13-3.15,3.06,3.06,0,0,0,.55-1.2c0-.34-.32-.58-.75-.75l-5.36-2a5.34,5.34,0,0,1-2.47-1.51,2.24,2.24,0,0,1-.46-1.45,1.64,1.64,0,0,1,.72-1.37l-.1.34a4.61,4.61,0,0,0-2-2.09c-.85-.48-1.85-.74-2.74-1.32a2.82,2.82,0,0,1-1.45-2.69,1.84,1.84,0,0,1,1-1.24,1.33,1.33,0,0,1,1.58.24l-.42.18c0-.61-.67-1-1.27-1.38a3.59,3.59,0,0,1-1.67-1.48,1.52,1.52,0,0,1,0-1.2,2.68,2.68,0,0,1,.7-.88c.53-.47,1.11-.82,1.53-1.28l0,.22c-.12-.41-.71-.73-.83-1.41a1.79,1.79,0,0,1,.71-1.57c.85-.76,2-.88,2.62-1.52a1.34,1.34,0,0,0,.49-1.14c0-.45-.16-.9-.23-1.38a1.52,1.52,0,0,1,.45-1.44,1.3,1.3,0,0,1,1.46-.1l-.26.08a1.93,1.93,0,0,1,1.6-1c.61-.1,1.19-.1,1.74-.15a2.9,2.9,0,0,0,1.47-.45,1.17,1.17,0,0,0,.41-.54c.07-.18-.06-.36-.22-.55a7.1,7.1,0,0,0-1.13-.88,2.22,2.22,0,0,1-.88-1.13,1.18,1.18,0,0,1,0-.72.77.77,0,0,1,.52-.49,1,1,0,0,1,.67,0,.55.55,0,0,1,.37.55l-.18-.09a1.47,1.47,0,0,1,2.24.64l-.15,0a1.5,1.5,0,0,1,1.72-.25,2.57,2.57,0,0,1,1,.84A5.15,5.15,0,0,1,399.08,191Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "404.983px 209.9px"
    },
    id: "elhit85ik71ah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.27,210.57c-.55-2.56-2.43-4.64-4.52-6.23a6.72,6.72,0,0,0-2.91-1.45,2.8,2.8,0,0,0-2.88,1.16l.15,1.83c-.23,2.91,2,5.36,3.08,8.08.47,1.18.84,2.6,2,3.11a2.73,2.73,0,0,0,1.95,0C406.63,216.19,407.82,213.14,407.27,210.57Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "402.181px 210.041px"
    },
    id: "elci5uxbs16v6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.53,224a5.86,5.86,0,0,0-.63-7.49c1.05-1.36.64-3.43-.47-4.74a11.36,11.36,0,0,0-4.3-2.76,7.89,7.89,0,0,0-9.27-5.63c-2.08-3-6.43-3.38-9.9-2.31a9.31,9.31,0,0,1-2.58.6,15.9,15.9,0,0,1-1.93-.24c-3.55-.43-7,2.11-8.36,5.43a6.81,6.81,0,0,1-.73,1.54,9.21,9.21,0,0,1-1.73,1.43,5.62,5.62,0,0,0-2.11,4.21c0,1.37.42,2.83-.14,4.08-.28.63-.8,1.15-1,1.8-.63,1.9,1.49,3.8,1.13,5.77-.07.4-.25.78-.35,1.17a3.44,3.44,0,0,0,.25,2.44,5.15,5.15,0,0,1,.79,1.74,6.09,6.09,0,0,1-.27,1.44c-.22,1.17,2.37,5.65,3.39,6.27l30.24-.15a5.67,5.67,0,0,0,4.31-4.93,2.1,2.1,0,0,1,.26-1.11,2.32,2.32,0,0,1,.82-.55c1.93-1.07,2.13-3.75,1.89-6a2.84,2.84,0,0,1,0-.92A3.38,3.38,0,0,1,407.53,224Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "386.428px 219.638px"
    },
    id: "elh9kt1vlxmns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.73,224.06a16.18,16.18,0,0,0-8.78-14,20,20,0,0,0-7.75-1.76,12.28,12.28,0,0,0-7.11,1.6c-1.66.41-7.69,6.09-7.92,12.16-.26,6.75-.31,15,.61,20,1.85,10.07,9.63,11.16,9.63,11.16l0,5.64,21.26.64Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "382.868px 233.88px"
    },
    id: "elpaampv553qk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,229.78a1.3,1.3,0,0,0,1.28,1.28,1.25,1.25,0,0,0,1.31-1.2,1.3,1.3,0,0,0-1.28-1.28A1.24,1.24,0,0,0,371,229.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.295px 229.82px"
    },
    id: "elerx6um902id",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.71,226c.17.16,1.13-.59,2.53-.62s2.43.64,2.58.47-.1-.38-.55-.69a3.57,3.57,0,0,0-2.08-.59,3.43,3.43,0,0,0-2,.71C369.77,225.65,369.63,226,369.71,226Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.276px 225.295px"
    },
    id: "elkcvaihp9oi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.15,236.84a9.13,9.13,0,0,0-2.28-.35c-.36,0-.7-.09-.76-.33a1.81,1.81,0,0,1,.21-1.06c.31-.88.64-1.79,1-2.74a48.45,48.45,0,0,0,2.19-7.16c-.16,0-1.4,3.07-2.76,7l-.95,2.76a2.11,2.11,0,0,0-.15,1.4.94.94,0,0,0,.6.51,2.28,2.28,0,0,0,.61.06A8.72,8.72,0,0,0,378.15,236.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "376.551px 231.084px"
    },
    id: "el4clihf0t5p6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.37,253.22a25.72,25.72,0,0,0,13.44-3.94s-3.31,7.11-13.45,6.41Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "384.085px 252.509px"
    },
    id: "elkck00rh8rvr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.15,220.79c.24.33,1.3.08,2.55.15s2.3.38,2.56.06c.12-.15,0-.48-.46-.81a3.73,3.73,0,0,0-2-.66,3.68,3.68,0,0,0-2.09.49C370.21,220.31,370,220.63,370.15,220.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.703px 220.332px"
    },
    id: "elch58p305xs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.28,229.77a1.31,1.31,0,0,1-1.27,1.29,1.24,1.24,0,0,1-1.32-1.19,1.29,1.29,0,0,1,1.26-1.29A1.25,1.25,0,0,1,386.28,229.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.985px 229.82px"
    },
    id: "eledt8fq0neso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.81,226.1c-.16.17-1.14-.57-2.53-.58s-2.43.67-2.58.5.1-.38.55-.7a3.55,3.55,0,0,1,2.06-.61,3.44,3.44,0,0,1,2,.68C388.75,225.72,388.89,226,388.81,226.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "386.244px 225.417px"
    },
    id: "elkrp0gmupzvf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.09,221.42c-.28.31-1.35,0-2.65-.06s-2.39.18-2.64-.15c-.1-.17.07-.48.55-.78a4.09,4.09,0,0,1,2.16-.49,4,4,0,0,1,2.1.67C389.07,220.94,389.21,221.27,389.09,221.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "386.452px 220.745px"
    },
    id: "elvil5vjtkiqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.47,233.82c0-.75.81-2.55,1.55-2.68,2-.36,5.56-.29,5.72,4.75.22,6.89-6.75,5.68-6.76,5.49S397.53,236.42,397.47,233.82Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "401.108px 236.296px"
    },
    id: "ele9921voxyhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.8,238.8s.12.08.33.17a1.23,1.23,0,0,0,.89,0,3,3,0,0,0,1.29-2.71,3.91,3.91,0,0,0-.39-1.71,1.35,1.35,0,0,0-.93-.89.62.62,0,0,0-.7.35c-.08.2,0,.33-.07.34s-.15-.11-.1-.39a.72.72,0,0,1,.25-.44.9.9,0,0,1,.66-.2,1.7,1.7,0,0,1,1.29,1,4.06,4.06,0,0,1,.47,1.91,3.12,3.12,0,0,1-1.65,3,1.3,1.3,0,0,1-1.11-.15C399.81,239,399.77,238.81,399.8,238.8Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "401.295px 236.304px"
    },
    id: "el1i5k2kg7st4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.77,222.34a4,4,0,0,0,2.11-3.75c.93.26,1.83-1,2.35-1.77s1.17-1.23,1.11-2.19a1.17,1.17,0,0,1,.05-.56,1.2,1.2,0,0,1,.75-.46,4.62,4.62,0,0,0,3-3.28,9.85,9.85,0,0,0,4.74.67,3.73,3.73,0,0,0,6.31-.43,3.37,3.37,0,0,0,2.28,1.6,10.13,10.13,0,0,0,2.86.09,4,4,0,0,0,2.71,4.41c.25.07.53.14.65.36a1,1,0,0,1-.09.77,3.11,3.11,0,0,0,2.18,3.91,2.32,2.32,0,0,0,.3,3.63c.25.15.58.32.55.61a.69.69,0,0,1-.14.3,4.55,4.55,0,0,0-1,2.3,1.66,1.66,0,0,0,1.41,1.81,2.28,2.28,0,0,0-.84,1.53c0,.6.63,1.2,1.18,1,.24-.1,3.65-.85,3.8-1.06,1.89-2.7-.64-5.56-.91-8.84a21.33,21.33,0,0,0-3.2-9.24,15.74,15.74,0,0,0-2.53-3.26,21.14,21.14,0,0,0-3.85-2.7,19.07,19.07,0,0,0-5.59-2.5c-3.74-.79-7.58.66-11,2.34a16,16,0,0,0-3.7,2.3,14.56,14.56,0,0,0-3.05,4.19,18.34,18.34,0,0,0-2.33,7.12",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.253px 218.999px"
    },
    id: "el0tcxebq321n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.36,220a2.6,2.6,0,0,1,.36-.75c.14-.23.34-.5.52-.85a3,3,0,0,0,.36-1.29,10.26,10.26,0,0,0-.07-1.71,7.35,7.35,0,0,1,0-2,5.58,5.58,0,0,1,1.68-3.19,9,9,0,0,1,1.07-.84,4.28,4.28,0,0,0,1-.92,6.08,6.08,0,0,0,.62-1.31,9,9,0,0,1,1.61-2.71,9.13,9.13,0,0,1,2.63-2.11,7.82,7.82,0,0,1,1.64-.66,7.25,7.25,0,0,1,1.81-.25c.31,0,.62,0,.93,0s.61.1.92.15a4.39,4.39,0,0,0,1.84,0c.61-.14,1.21-.37,1.85-.54a11.5,11.5,0,0,1,1.94-.39,11.34,11.34,0,0,1,2-.07,10.11,10.11,0,0,1,2,.33,6.73,6.73,0,0,1,3.52,2.21l.27.33-.12,0a8,8,0,0,1,9.4,5.71l-.06-.07a24.14,24.14,0,0,1,2.44,1.22,7.47,7.47,0,0,1,2,1.72,4.77,4.77,0,0,1,.95,2.36,3.27,3.27,0,0,1-.61,2.34v-.11a5.7,5.7,0,0,1,1.67,3.5,5.88,5.88,0,0,1-.64,3.44,5.46,5.46,0,0,1-.45.69c-.16.22-.33.42-.46.63a1.53,1.53,0,0,0-.23.68,5.79,5.79,0,0,0,0,.72,11.29,11.29,0,0,1,0,2.61,5.35,5.35,0,0,1-.63,2,3.36,3.36,0,0,1-1.05,1.14c-.35.24-.66.34-.83.47a1.94,1.94,0,0,0-.25.22.88.88,0,0,1,.23-.24c.17-.14.49-.25.82-.49a3.28,3.28,0,0,0,1-1.14,5.37,5.37,0,0,0,.61-2,11.82,11.82,0,0,0,0-2.59,4.47,4.47,0,0,1,0-.74,1.7,1.7,0,0,1,.24-.74c.14-.22.31-.43.47-.64a5,5,0,0,0,.42-.67,5.65,5.65,0,0,0,.61-3.36,5.56,5.56,0,0,0-1.63-3.4l0-.05,0-.06a3.08,3.08,0,0,0,.57-2.22,4.57,4.57,0,0,0-.92-2.26,6.94,6.94,0,0,0-2-1.67,21.84,21.84,0,0,0-2.42-1.21l0,0v-.05a7.45,7.45,0,0,0-3.34-4.51,7.55,7.55,0,0,0-5.8-1l-.07,0,0-.06-.26-.32a6.54,6.54,0,0,0-3.41-2.14,10.45,10.45,0,0,0-2-.32,11.85,11.85,0,0,0-2,.06,11.06,11.06,0,0,0-1.92.38c-.62.17-1.22.4-1.86.54a5,5,0,0,1-1,.13,6,6,0,0,1-.95-.09l-.92-.14a6.8,6.8,0,0,0-.9-.06,6.92,6.92,0,0,0-1.76.24,8.07,8.07,0,0,0-1.61.64,9.11,9.11,0,0,0-4.17,4.71,5.43,5.43,0,0,1-.65,1.35,4.35,4.35,0,0,1-1.07.95,8.87,8.87,0,0,0-1.05.82,4.91,4.91,0,0,0-.81,1,5.58,5.58,0,0,0-.86,2.14,7.55,7.55,0,0,0,0,2,10.19,10.19,0,0,1,.05,1.72,3.31,3.31,0,0,1-.38,1.32c-.2.35-.4.62-.55.85a3.56,3.56,0,0,0-.3.53A1.07,1.07,0,0,1,364.36,220Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "386.465px 216.622px"
    },
    id: "elc7l48589s45",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.59,202s-.18-.1-.52-.26a4.76,4.76,0,0,0-1.51-.4,4.31,4.31,0,0,0-2.26.38,4.47,4.47,0,0,0-2,1.91,3.89,3.89,0,0,0-.33.79.84.84,0,0,0,.07.72l.17.23-.28-.07a2.82,2.82,0,0,0-2.12.3,2.72,2.72,0,0,0-1.14,1.3,3.1,3.1,0,0,0-.25,1.14c0,.28,0,.43,0,.43s0,0,0-.11,0-.18,0-.32a3,3,0,0,1,.2-1.19,2.78,2.78,0,0,1,1.17-1.4,3,3,0,0,1,2.26-.35l-.1.16a1,1,0,0,1-.11-.89,3.64,3.64,0,0,1,.35-.84,4.61,4.61,0,0,1,2.12-2,4.42,4.42,0,0,1,2.35-.35,4.37,4.37,0,0,1,1.54.48,3.7,3.7,0,0,1,.37.23C389.56,201.94,389.6,202,389.59,202Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "384.505px 204.808px"
    },
    id: "elma8zty3j0em",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,209.65a1.22,1.22,0,0,1-.24.25,4.28,4.28,0,0,1-.77.56,3.35,3.35,0,0,1-1.36.44,2.49,2.49,0,0,1-1.72-.48l.15,0-.2.29-.23.28a4.25,4.25,0,0,1-1.7,1.11,4.54,4.54,0,0,1-1.63.24,3.76,3.76,0,0,1-1.09-.23,1.53,1.53,0,0,1-.37-.18,5.93,5.93,0,0,0,1.46.26,4.51,4.51,0,0,0,1.57-.27,4.33,4.33,0,0,0,1.61-1.07l.22-.26.18-.27.07-.1.08.07a2.37,2.37,0,0,0,1.59.46,3.48,3.48,0,0,0,1.31-.38C400.57,210,400.92,209.62,401,209.65Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "396.42px 210.996px"
    },
    id: "el9sm852sp5gp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.73,216s0,0,0,.13a.94.94,0,0,1-.14.33,1.81,1.81,0,0,1-1.1.76,3.44,3.44,0,0,1-2-.17,9.9,9.9,0,0,1-1.1-.4,1.94,1.94,0,0,1-1-.85l0-.11.16,0a7.9,7.9,0,0,1-2,1.27,3.54,3.54,0,0,1-1.93.24,2.65,2.65,0,0,1-1.2-.51,2.15,2.15,0,0,1-.26-.25l-.07-.11s.13.12.38.29a2.65,2.65,0,0,0,1.17.44,3.57,3.57,0,0,0,1.84-.28,8,8,0,0,0,2-1.25l.11-.09.05.13,0,.09a1.69,1.69,0,0,0,.87.75,10.16,10.16,0,0,0,1.07.41,3.45,3.45,0,0,0,1.88.21,1.8,1.8,0,0,0,1.06-.66A3.82,3.82,0,0,0,404.73,216Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "399.41px 216.368px"
    },
    id: "ela3pacth7owd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.57,191.19s-.12,0-.33.06a1.63,1.63,0,0,0-.76.52,2.14,2.14,0,0,0-.49,1.32,6.37,6.37,0,0,0,.3,1.88l0,.11h-.11a3.89,3.89,0,0,0-2.37.78,3,3,0,0,0-1.25,2.44,2.79,2.79,0,0,0,1.05,2.27l.24.18h-.3A3.58,3.58,0,0,0,405,202a3.41,3.41,0,0,0-.83,2.14,3.6,3.6,0,0,0,.27,1.51c.13.34.24.51.23.52a.73.73,0,0,1-.09-.12,2.18,2.18,0,0,1-.21-.37,3.73,3.73,0,0,1-.33-1.55,3.55,3.55,0,0,1,.83-2.24,3.75,3.75,0,0,1,2.72-1.3l-.06.18a3,3,0,0,1-1.14-2.43,3.13,3.13,0,0,1,.37-1.49,3.48,3.48,0,0,1,1-1.11,4.14,4.14,0,0,1,2.49-.8l-.09.11a6.44,6.44,0,0,1-.27-1.92,2.22,2.22,0,0,1,.56-1.39,1.55,1.55,0,0,1,.82-.5.79.79,0,0,1,.25,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "407.805px 198.68px"
    },
    id: "el9gdw03dqtb9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.2,205.85l-.12.07c-.07,0-.18.1-.34.16a4.94,4.94,0,0,1-1.38.35,5.51,5.51,0,0,1-2.17-.21,5.33,5.33,0,0,1-2.36-1.47l.16,0a4.42,4.42,0,0,1-3.05,2.2,3.34,3.34,0,0,1-3.48-1.75h.18a2.76,2.76,0,0,1-.8,1.18,3.62,3.62,0,0,1-1.12.67,5.07,5.07,0,0,1-2.09.27,10.51,10.51,0,0,1-1.36-.19,2.8,2.8,0,0,1-.47-.12,2.82,2.82,0,0,1,.48.06,13.36,13.36,0,0,0,1.36.13,5.11,5.11,0,0,0,2-.3,3,3,0,0,0,1.8-1.76l.07-.24.11.23a3.13,3.13,0,0,0,3.26,1.62,4.23,4.23,0,0,0,2.92-2.09l.07-.11.09.1a5.09,5.09,0,0,0,2.26,1.44,5.48,5.48,0,0,0,2.11.25A6.72,6.72,0,0,0,424.2,205.85Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "415px 205.943px"
    },
    id: "elhxcr896grzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.19,216.09s0,0-.08.13a.67.67,0,0,1-.38.18,3.28,3.28,0,0,1-1.53-.22,3.73,3.73,0,0,1-2.35-4.16v0l.15.11a4.46,4.46,0,0,1-2.75.45,5,5,0,0,1-2.12-.86,5.56,5.56,0,0,1-1.12-1,2,2,0,0,1-.32-.47,7.9,7.9,0,0,0,1.52,1.39,5.22,5.22,0,0,0,2.06.79,4.42,4.42,0,0,0,2.63-.44l.18-.1,0,.21v0a3.61,3.61,0,0,0,2.2,4,3.36,3.36,0,0,0,1.47.28A.73.73,0,0,0,417.19,216.09Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "411.94px 213.332px"
    },
    id: "el046lynkrszo5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.51,191.77a5.92,5.92,0,0,0-.27,2.13,5,5,0,0,0,.72,2.17,4.76,4.76,0,0,0,2.14,1.79,4.56,4.56,0,0,0,1.58.38h.13l0,.12a6,6,0,0,0,.23,4,3.74,3.74,0,0,0,.29.6.51.51,0,0,0,.37.28.36.36,0,0,0,.28-.09s.05-.09.06-.09,0,0,0,.11a.37.37,0,0,1-.3.14.61.61,0,0,1-.45-.29,3.48,3.48,0,0,1-.33-.61,5.8,5.8,0,0,1-.49-1.78,6,6,0,0,1,.18-2.3l.09.13a4.72,4.72,0,0,1-1.65-.39,4.86,4.86,0,0,1-2.22-1.87,4.78,4.78,0,0,1-.7-2.27,4.88,4.88,0,0,1,.18-1.6,2.51,2.51,0,0,1,.16-.4C396.48,191.82,396.5,191.77,396.51,191.77Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "399.104px 197.54px"
    },
    id: "elwgm3ikn9t2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.56,258.29s-1,11.9,8.29,12.8,12.95-7.51,13-11.44l-4.43-2.76Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "388.189px 264.023px"
    },
    id: "elgrhw28g3c46",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.51,240.47c.11.16,0,.05.16.17a5.61,5.61,0,0,0,2,1.07,1.81,1.81,0,0,0,1.94-.57,1.55,1.55,0,0,0-.19-1.78,2.93,2.93,0,0,0-1.77-1l-.19,0a1.71,1.71,0,0,0-2,1.84A.72.72,0,0,0,378.51,240.47Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "380.63px 240.064px"
    },
    id: "eltm7nysj3br7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.45,238.87a9.8,9.8,0,0,1-2.77,1.41,9.21,9.21,0,0,1-3,.93,9.8,9.8,0,0,1,2.77-1.41A9.07,9.07,0,0,1,383.45,238.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "380.565px 240.04px"
    },
    id: "elduwz19k0hy6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.26,261.62l12.94-4.31c3.81,9.32,16.2,8,21.53-.74l15.42,5.24,8.67,17.34-6.51,36.63,11.91,23.59-31.92,6-27.88-12.93-2.38-1.8-4.74-62.41Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "394.76px 300.97px"
    },
    id: "elk2o167xfhh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.26,261.62s-10.28,4.27-11.35,15.63c-.42,4.39-3.52,24.95-3.52,24.95l-14.53-1.73-3.51,11.59s16.25,8.47,21.27,9.57c8.66,1.9,12.85-3,12.85-3Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "348.41px 291.844px"
    },
    id: "el749mdkvff9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,275.48a2.28,2.28,0,0,1,0,.57c0,.4,0,.94-.05,1.61s-.06,1.56,0,2.55,0,2.13,0,3.38.08,2.62.18,4.09.21,3,.34,4.69c.31,3.3.71,6.91,1.21,10.71,1,7.58,2,14.44,2.41,19.44.13,1.25.21,2.38.27,3.38s.13,1.85.15,2.55,0,1.21.05,1.61a2.28,2.28,0,0,1,0,.57,5,5,0,0,1-.07-.56l-.12-1.61q-.06-1.05-.21-2.55c-.09-1-.19-2.12-.33-3.36-.52-5-1.52-11.84-2.52-19.43-.5-3.79-.9-7.42-1.18-10.72-.12-1.66-.26-3.23-.31-4.7s-.12-2.85-.13-4.11,0-2.39,0-3.38.05-1.86.11-2.56.09-1.2.13-1.61A4.11,4.11,0,0,1,361.5,275.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "363.632px 303.055px"
    },
    id: "elmk8si3b2etr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.2,277.65s4.43-4.29,6.12-3.77a9.28,9.28,0,0,1,3.12,1.86s1.69-1,2.6,0a15.44,15.44,0,0,1,1.82,2.82s1.61-.23,2.86,1.85,4.32,9.07,5.47,10.24a10.44,10.44,0,0,0,4.19,2.41c1.65.59,15.46,5.25,15.46,5.25L370.75,311s-20.29-11.87-21.07-12.65-6.89-4.81-7.8-7.29-7.68-10-7.68-10Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "355.02px 292.418px"
    },
    id: "elehue6q25wlq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.63,282.68s0,.19-.24.48a2.79,2.79,0,0,1-1.18.94l.08-.13a4.14,4.14,0,0,1-.63,2.78,3.55,3.55,0,0,1-.56.68,1.54,1.54,0,0,1-.89.44,1,1,0,0,1-.93-.53,2.51,2.51,0,0,1-.29-1c-.16-1.16-.31-2.24-.42-3.25a2,2,0,0,1,.37-1.47,3,3,0,0,1,1.05-.77,9.18,9.18,0,0,0,1.59-.8c.33-.24.46-.44.49-.42s-.07.24-.4.54a7.76,7.76,0,0,1-1.56.93,2.85,2.85,0,0,0-.92.71,1.72,1.72,0,0,0-.26,1.25c.13,1,.28,2.09.44,3.23.06.6.32,1.23.82,1.18a2,2,0,0,0,1.18-.93A4,4,0,0,0,346,284v-.09l.09,0a3,3,0,0,0,1.17-.8C347.51,282.82,347.61,282.66,347.63,282.68Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "345.09px 283.75px"
    },
    id: "elm9n2nfqlria",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.92,286.44c0,.09-.71-.17-1.18-.87s-.48-1.42-.38-1.43.27.59.7,1.21S349,286.34,348.92,286.44Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "348.119px 285.299px"
    },
    id: "el28dkhcl9cmeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.42,294.59c-.12,0-.07-1.28-.56-2.75s-1.25-2.48-1.15-2.55a4.64,4.64,0,0,1,1.52,2.43A4.72,4.72,0,0,1,348.42,294.59Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "347.63px 291.94px"
    },
    id: "elzhkp5ivpp9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.09,284s0,.23-.18.62a3.12,3.12,0,0,1-1.05,1.42,1.75,1.75,0,0,1-1.24.32,1.73,1.73,0,0,1-1.19-.86,5.14,5.14,0,0,1-.56-1.46,11.77,11.77,0,0,1-.29-1.63,4.76,4.76,0,0,1,.77-3.11,7.91,7.91,0,0,1,1.76-1.92c.58-.46,1.08-.79,1.42-1a2.19,2.19,0,0,1,.57-.3c0,.06-.72.57-1.81,1.52a8.06,8.06,0,0,0-1.64,1.9,4.59,4.59,0,0,0-.69,2.89,13.19,13.19,0,0,0,.28,1.57,5,5,0,0,0,.49,1.37,1.45,1.45,0,0,0,.94.73,1.54,1.54,0,0,0,1-.24,3.11,3.11,0,0,0,1.06-1.26A2.67,2.67,0,0,1,343.09,284Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "340.828px 281.227px"
    },
    id: "elc7puh6s0u68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkc2sqshw1ro"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "392.455px 314.585px"
    },
    className: "animable",
    id: "el84z20ouduho"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.55,317.12c-1.26,1.25-2.67,2.54-4.42,2.83a9,9,0,0,1-4.58-.87l-25-9.5-2,2.76c8.59,7,19.32,13.07,29.92,15.64a12.65,12.65,0,0,0,10.19-2c2.22-1.62,3.58-4.15,4.7-6.66a62.63,62.63,0,0,0,5-18.46A124.24,124.24,0,0,1,403.55,317.12Z",
    id: "el7e0q8lscd28",
    className: "animable",
    style: {
      transformOrigin: "392.455px 314.585px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M410,269.73c-.63.67-15.15,31.66-15.15,31.66l-28.17-6.3L363.5,310.6s25.53,11.33,32.21,13.34c4.27,1.29,7.2,1,11.38-3s14.77-29.65,16-34.81c1.12-4.91,5.17-17.95-8.9-24.36Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "393.997px 293.197px"
    },
    id: "elevfjm77jtcu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.14,292.1a1.61,1.61,0,0,0,.81-2.37l-16.7-28.07a1.26,1.26,0,0,0-1.42-.63l-15.95,4.41c-1.26.24-1.61,2.34-1.07,3.23l16.81,26.77a3.35,3.35,0,0,0,3.06,1.16",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "327.381px 278.814px"
    },
    id: "el8p7vpsho4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.68,291.64a2.49,2.49,0,0,1-.32-.45l-.84-1.35-3.06-5-10-16.58c-1-1.61-1.91-3.25-2.84-4.7a1.73,1.73,0,0,0-.93-.59,1.94,1.94,0,0,0-1.06.09l-2.15.59-7.43,2L311,267l-1.37.34a2,2,0,0,1-.48.09,2.26,2.26,0,0,1,.46-.17l1.36-.41,5-1.45,7.42-2.09,2.14-.61a2.27,2.27,0,0,1,1.19-.1,2.08,2.08,0,0,1,1.09.69c1,1.54,1.89,3.12,2.88,4.74l9.93,16.65c1.24,2.12,2.26,3.84,3,5.07l.8,1.39A3.83,3.83,0,0,1,344.68,291.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "326.915px 277.101px"
    },
    id: "elpwp4c2kqmy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.34,269.77a.88.88,0,1,1-.88-.9A.89.89,0,0,1,321.34,269.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "320.46px 269.75px"
    },
    id: "elyn3pm6v62q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.84,275.57c-.09.55-3.69,11.46-4.23,12.53s0,3.13,0,3.13-1.25,2.61.72,4.41c0,0,.15,2.34,1.2,2.79a5.42,5.42,0,0,1,1.86,1.53s5.94,8.09,6.57,8.9a45.07,45.07,0,0,0,3.39,3.2s8.39-3.05,3.94-11l-2.53-1.6.87-6.46s2.07-1.63,1.62-2.72a1,1,0,0,0-1.35-.63s.79-2.25-1.14-2.61l-7.41,3.58s5.49-5.53,4.68-7.06-1.17-1.28-1.17-1.28l-7.11,6s1.77-6.62,2.25-8.73C324.9,275.57,321.84,275.57,321.84,275.57Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "326.905px 293.815px"
    },
    id: "el927m8ruzg5l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.8,290a8.14,8.14,0,0,1-1.34,1.45,25.64,25.64,0,0,1-3.78,2.89,25.91,25.91,0,0,1-4.25,2.14,8.29,8.29,0,0,1-1.89.57,13,13,0,0,1,1.78-.82,36.79,36.79,0,0,0,4.16-2.21,35.8,35.8,0,0,0,3.8-2.78A14.25,14.25,0,0,1,333.8,290Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "328.17px 293.525px"
    },
    id: "ela79in14o8lk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.86,282.24a6.68,6.68,0,0,1-1.24,1.39c-.82.8-2,1.84-3.39,2.93a27,27,0,0,1-5.24,3.55,15.06,15.06,0,0,1,1.46-1.14c.92-.68,2.17-1.64,3.54-2.72s2.59-2.08,3.45-2.82A12.44,12.44,0,0,1,328.86,282.24Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "323.925px 286.175px"
    },
    id: "elfmp9ljfyog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.69,291.7s.13-.16.45-.1a1.08,1.08,0,0,1,.77,1,2.67,2.67,0,0,1-.83,1.67c-.43.51-.93,1.07-1.47,1.63a30.92,30.92,0,0,1-2.95,2.71,6.23,6.23,0,0,1-1.36.95c-.07-.09,1.89-1.68,4-3.92.54-.56,1-1.1,1.48-1.61a2.56,2.56,0,0,0,.83-1.43.92.92,0,0,0-.54-.85C332.86,291.65,332.7,291.73,332.69,291.7Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "330.604px 295.573px"
    },
    id: "ele3xjpm5zlou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,299.15c-.09.06-.47-.37-1-.8s-1-.72-1-.82.64,0,1.22.52S332.1,299.09,332,299.15Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "331.009px 298.325px"
    },
    id: "elqa3woxfuwj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.21,303.7c.05,0,.05.39-.2.93a3.43,3.43,0,0,1-1.59,1.66,3.53,3.53,0,0,1-2.29.29c-.59-.14-.89-.37-.87-.41a7.76,7.76,0,0,1,.91.14,3.66,3.66,0,0,0,3.6-1.8C332.06,304,332.15,303.69,332.21,303.7Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "329.748px 305.178px"
    },
    id: "elabdfkcnvr7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.88,287.07a9.42,9.42,0,0,1-1.66,1c-1,.55-2.51,1.27-4.16,2s-3.15,1.35-4.26,1.77a9,9,0,0,1-1.82.6,9.53,9.53,0,0,1,1.72-.85l4.21-1.88,4.19-1.89A9.1,9.1,0,0,1,332.88,287.07Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "326.93px 289.755px"
    },
    id: "el3wtg0orzr63",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.19,275.48s-.06.17-.2.48-.35.77-.62,1.36l-2.44,5.21c-2.14,4.51-5.2,11-8.95,18.92l-.06.11-.11,0-28.18-6.26.23-.14c-1,5-2.08,10.16-3.18,15.51l-.11-.22,2.22,1c9.59,4.19,18.74,8.19,27.21,11.42a21.66,21.66,0,0,0,6.33,1.63,8.81,8.81,0,0,0,5.7-1.94,14.76,14.76,0,0,0,2.21-1.94,8,8,0,0,0,.88-1.11c.26-.4.55-.77.78-1.17.48-.81.94-1.59,1.36-2.39s.82-1.56,1.2-2.33c3-6.15,5.12-11.3,6.6-14.84l1.67-4.09.43-1.06c.1-.24.16-.36.16-.36l-.12.37-.4,1.08c-.36.95-.89,2.34-1.6,4.12-1.44,3.56-3.49,8.72-6.49,14.9-.38.77-.77,1.56-1.2,2.35s-.88,1.59-1.36,2.4c-.23.41-.52.79-.78,1.2a8.83,8.83,0,0,1-.91,1.15,15.78,15.78,0,0,1-2.24,2,10.91,10.91,0,0,1-2.72,1.51,8.08,8.08,0,0,1-3.18.51,22,22,0,0,1-6.45-1.64c-8.49-3.22-17.64-7.21-27.23-11.4l-2.22-1-.14-.07,0-.15c1.09-5.34,2.16-10.54,3.18-15.51l0-.19.18.05,28.16,6.33-.17.08,9.08-18.87c1.08-2.22,1.92-4,2.51-5.17.28-.58.51-1,.66-1.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "391.8px 300.174px"
    },
    id: "el6p9djzbe5l8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.18,322.42a4.29,4.29,0,0,1-.7.63c-.46.39-1.16.92-2.05,1.53a37.54,37.54,0,0,1-15.64,6.13c-1.07.15-1.94.24-2.55.26a3.59,3.59,0,0,1-.94,0,5.39,5.39,0,0,1,.93-.16c.6-.07,1.46-.2,2.52-.38a43.67,43.67,0,0,0,8.07-2.27,43.15,43.15,0,0,0,7.46-3.82c.9-.58,1.62-1.07,2.11-1.42A4.1,4.1,0,0,1,418.18,322.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "407.24px 326.71px"
    },
    id: "el3yug16x1f4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.51,316.67c-.07,0,.12-.95.11-2.48a16.17,16.17,0,0,0-.25-2.67,18.13,18.13,0,0,0-.9-3.14,18.33,18.33,0,0,0-1.54-2.9,16.57,16.57,0,0,0-1.67-2.09c-1.06-1.1-1.85-1.64-1.81-1.7s.22.1.58.34a5,5,0,0,1,.63.48,9,9,0,0,1,.79.69,13.94,13.94,0,0,1,1.78,2.08,16.42,16.42,0,0,1,1.59,3,15.91,15.91,0,0,1,.9,3.23,13.47,13.47,0,0,1,.17,2.73,8,8,0,0,1-.08,1.05,5.89,5.89,0,0,1-.12.78C355.6,316.45,355.54,316.68,355.51,316.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "352.674px 309.174px"
    },
    id: "elb6dk9gykjio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.41,312.83c-.07,0-.19-.74-.56-1.89a15.49,15.49,0,0,0-5.36-7.59c-1-.74-1.63-1.1-1.6-1.16a1.63,1.63,0,0,1,.5.19,10.35,10.35,0,0,1,1.26.74,13.9,13.9,0,0,1,3.42,3.39,13.64,13.64,0,0,1,2,4.35,8.82,8.82,0,0,1,.28,1.44A1.54,1.54,0,0,1,358.41,312.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "354.651px 307.51px"
    },
    id: "elnsf6ngl922n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,325.41s-.14.19-.44.49-.75.71-1.32,1.2a44.46,44.46,0,0,1-4.7,3.53,46.17,46.17,0,0,1-5.11,2.89c-.68.32-1.24.57-1.63.72a2,2,0,0,1-.62.2,23.29,23.29,0,0,1,2.13-1.17c1.31-.7,3.11-1.72,5-3s3.57-2.49,4.74-3.41A20.45,20.45,0,0,1,418,325.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "411.09px 329.925px"
    },
    id: "eljla8f3am65h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.75 388.9 304 417.76 318.04 428.33 340.16 401.3 321.75 388.9",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "322.08px 408.615px"
    },
    id: "elyqs8o9dtxqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.24,415.47l-.71.93s-20.61-5.63-23-2.76L313,437.27l7.43-10.81A22.52,22.52,0,0,1,305.24,415.47Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "300.98px 425.047px"
    },
    id: "elea6cemerqys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli11p58blny"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "313.536px 428.375px"
    },
    className: "animable",
    id: "elbh919h6f9g8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.71,427.42a1.62,1.62,0,0,1-.21,2.14,1.55,1.55,0,0,1-2.12-.19,1.7,1.7,0,0,1,.23-2.26,1.6,1.6,0,0,1,2.18.44",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.536px 428.375px"
    },
    id: "ell1h6wwi1q3",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elxt46vft6my"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "298.13px 425.092px"
    },
    className: "animable",
    id: "elab48wdwi15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313,437.27l1.78-2.6L283.92,413s-1.86-.44-2.44.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "298.13px 425.092px"
    },
    id: "elhklg3pd2qh",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M304.36,416.41c-.11.16.6.8,1,1.86s.3,2,.49,2.06.62-1,.13-2.29S304.43,416.24,304.36,416.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "305.277px 418.355px"
    },
    id: "eluidut0zhmu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,415.3c-.15.12.32.88.36,1.92s-.34,1.85-.18,1.95.91-.68.84-2S300.14,415.15,300,415.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "300.498px 417.229px"
    },
    id: "elfnsyvz4di6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.19,417.84c.11.14.9-.47,1.14-1.61s-.23-2-.39-1.93-.06.86-.27,1.79S295,417.71,295.19,417.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "295.771px 416.078px"
    },
    id: "elb6w03w7fwt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.34 414.8 358.87 458.56 373.63 453.64 378.82 414.24 358.34 414.8",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "368.58px 436.4px"
    },
    id: "elup020a83ou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.71,451s-9.65,8.05-15.19,2.34l-1,3.11-3.92,21.81a2.85,2.85,0,0,0,2,3.26,2.9,2.9,0,0,0,3-.83c3.88-4.31,18.07-20.23,17.74-22.19l-.54-5.22a2.67,2.67,0,0,0-2-2.28Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "364.948px 466.323px"
    },
    id: "el9r0tv2s8bqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldc99cupe9mg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "366.061px 469.181px"
    },
    className: "animable",
    id: "el9hy2pcub9z6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356,481.64l20-24.94.1,1.14a3.18,3.18,0,0,1-.82,2.62c-1.57,2.51-6,8.21-16.78,20.24a2.89,2.89,0,0,1-2.51.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "366.061px 469.181px"
    },
    id: "elzcmd02tjn2i",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elw86rbvgawa"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "373.536px 454.801px"
    },
    className: "animable",
    id: "elzyy5gd95vcl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.5,453.6a1.65,1.65,0,0,0-.28,2.22,1.69,1.69,0,0,0,2.26.28,1.6,1.6,0,1,0-2.1-2.39",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "373.536px 454.801px"
    },
    id: "elzzgxlocozo",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M361.34,469.32a8.55,8.55,0,0,0-2.61-1.89,8.83,8.83,0,0,0-3.23-.31c0-.07.3-.31.94-.45a4.55,4.55,0,0,1,2.52.21,4.39,4.39,0,0,1,2,1.49C361.33,468.9,361.41,469.29,361.34,469.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "358.431px 467.95px"
    },
    id: "elkpdrgcp8x3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.69,473.1a23.27,23.27,0,0,0-2.56-1,21.47,21.47,0,0,0-2.73-.1c-.09-.13,1.19-.82,2.86-.48S359.82,473,359.69,473.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "357.049px 472.263px"
    },
    id: "elrehlwy0ceua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.61,464.37c-.12.14-1.6-1.09-3.84-1.71s-4.16-.4-4.18-.58a6.47,6.47,0,0,1,4.36,0A6.32,6.32,0,0,1,364.61,464.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.6px 463.041px"
    },
    id: "eldl7d4f0in25",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.51,457.85c-.06.17-1.64-.32-3.64-.21s-3.53.7-3.6.54,1.43-1.05,3.58-1.14A5.64,5.64,0,0,1,364.51,457.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.889px 457.603px"
    },
    id: "els4axe48icn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.74,457.68a2.07,2.07,0,0,1,.06-1,7.07,7.07,0,0,1,1.1-2.59,3.17,3.17,0,0,1,1.53-1.38,1.16,1.16,0,0,1,1.25.36,1.81,1.81,0,0,1,.32,1.26,4,4,0,0,1-3.87,3.29,4.63,4.63,0,0,1-4.32-2.77,1.57,1.57,0,0,1,.05-1.32,1.15,1.15,0,0,1,1.23-.47,4,4,0,0,1,1.73,1.09,7.83,7.83,0,0,1,1.67,2.26,2.56,2.56,0,0,1,.34,1,12.64,12.64,0,0,0-2.31-2.92,3.58,3.58,0,0,0-1.53-.91.6.6,0,0,0-.67.25,1.07,1.07,0,0,0,0,.86,4.15,4.15,0,0,0,3.78,2.37,3.48,3.48,0,0,0,3.32-2.75,1.3,1.3,0,0,0-.18-.89.64.64,0,0,0-.69-.21,3,3,0,0,0-1.32,1.14A10.45,10.45,0,0,0,359.74,457.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "359.851px 455.166px"
    },
    id: "ele5tos0l7h4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.19,327.74s-6.56-2.85-14.17,1.7c-5.83,3.48-43.25,64-43.25,64L336,410.06l33.22-49.27,13.6,11.72s28.16,5.71,36.57,2.1,13-13.16,12.32-21.33a41.44,41.44,0,0,0-3.46-13.91c-9.7,1.48-16.28,5-29.59-1.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.773px 368.459px"
    },
    id: "el9qy0d5ttn8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.81,359.35s15.6-6.63,20.39,5.42c1.61,4.06.59,21.79-.21,38.38-.79,16.32-1.36,31.54-1.36,31.54L354.07,434l-1-43.71s.29-16.1,2.81-21.29S360.81,359.35,360.81,359.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "367.561px 396.11px"
    },
    id: "el409cbdywrhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.06,342.09l-.15.25-.48.74-1.87,2.83-7,10.6c-6,9.08-14.33,21.9-23.64,37l-.05-.25L333.32,408l2.76,1.89-.27.05,33.27-49.23v0h0a11.84,11.84,0,0,0,3.29-4.17,16.51,16.51,0,0,0,1.39-4.56,13.82,13.82,0,0,0-3.41-11.57c-.37-.4-.67-.7-.88-.89l-.31-.29a9.32,9.32,0,0,1,1.25,1.13,13.41,13.41,0,0,1,2.64,4.06A13.71,13.71,0,0,1,374,352a15.93,15.93,0,0,1-1.38,4.63,11.79,11.79,0,0,1-3.34,4.28l0,0-33.17,49.3-.11.16-.16-.11-2.76-1.89L311.66,393.6l-.14-.1.09-.14c9.33-15.14,17.74-27.93,23.75-37l7.1-10.55,1.92-2.8.5-.71A2.87,2.87,0,0,1,345.06,342.09Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "342.845px 374.8px"
    },
    id: "elm58qaztl23",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.16,358.24a15.48,15.48,0,0,0-.26-4.26,17.13,17.13,0,0,0-5.25-8.68,36.35,36.35,0,0,0-8.69-5.56l-2.85-1.36a7.77,7.77,0,0,1-1-.53,5.48,5.48,0,0,1,1.09.39c.69.28,1.69.7,2.9,1.25a34.26,34.26,0,0,1,8.84,5.52,16.81,16.81,0,0,1,5.26,8.92,11.56,11.56,0,0,1,.19,3.16c0,.38-.1.66-.12.86S416.18,358.24,416.16,358.24Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "407.267px 348.045px"
    },
    id: "eltd2p7xq0m8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.63,434.69a7.75,7.75,0,0,1,0-.84c0-.6,0-1.4.05-2.41.07-2.13.17-5.14.3-8.84.3-7.5.72-17.79,1.18-29.15.24-5.7.47-11.12.68-16.05s.8-9.47-.66-12.92a10,10,0,0,0-2.93-3.94,9,9,0,0,0-3.3-1.72,14,14,0,0,0-2.34-.49c-.54-.06-.83-.07-.83-.09s.07,0,.21,0a4.64,4.64,0,0,1,.63,0,11.69,11.69,0,0,1,2.38.39,9.82,9.82,0,0,1,6.52,5.72,15.38,15.38,0,0,1,1,6.06c0,2.2-.12,4.54-.21,7-.2,4.94-.41,10.37-.64,16.06-.52,11.36-1,21.64-1.33,29.15-.2,3.69-.36,6.7-.47,8.83-.06,1-.11,1.81-.14,2.4A4.7,4.7,0,0,1,379.63,434.69Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "377.155px 396.46px"
    },
    id: "eln74w4gtqodh",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformaInvoices);
export default __webpack_public_path__ + "static/media/PerformaInvoices.cf41d550.svg";
export { ForwardRef as ReactComponent };